// import React, { useEffect, useState } from "react";
// import { MapContainer, TileLayer, GeoJSON, LayersControl } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import * as turf from "@turf/turf";

// const Hotspot = () => {
//   const [hotspotData, setHotspotData] = useState(null);
//   const [municipalityData, setMunicipalityData] = useState(null);
//   const [submunicipalityData, setSubmunicipalityData] = useState(null);
//   const [sucoData, setSucoData] = useState(null);
//   const [hotspotTable, setHotspotTable] = useState([]);

//   const center = [-9.1742, 124.7275]; // Timor-Leste
//   const INITIAL_VIEW_STATE = {
//     zoom: 7.5,
//   };

//   // Fetch hotspot data
//   useEffect(() => {
//     fetch("/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson")
//       .then((response) => response.json())
//       .then((data) => setHotspotData(data))
//       .catch((error) => console.error("Error loading hotspot data:", error));
//   }, []);

//   // Fetch municipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm1_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setMunicipalityData(data))
//       .catch((error) => console.error("Error loading municipality data:", error));
//   }, []);

//   // Fetch submunicipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm2_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSubmunicipalityData(data))
//       .catch((error) => console.error("Error loading submunicipality data:", error));
//   }, []);

//   // Fetch suco data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm3_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSucoData(data))
//       .catch((error) => console.error("Error loading suco data:", error));
//   }, []);

//   // Process hotspot data to build the table
//   useEffect(() => {
//     if (hotspotData && sucoData && submunicipalityData && municipalityData) {
//       const tableData = hotspotData.features.map((hotspot) => {
//         // Get centroid of hotspot polygon
//         const centroid = turf.centroid(hotspot);

//         // Find suco containing the hotspot centroid
//         let sucoName = "Unknown";
//         let submunicipalityName = "Unknown";
//         let municipalityName = "Unknown";

//         const sucoFeature = sucoData.features.find((suco) =>
//           turf.booleanPointInPolygon(centroid, suco)
//         );
//         if (sucoFeature && sucoFeature.properties) {
//           sucoName = sucoFeature.properties.ADM3 || "Unknown";

//           // Find submunicipality containing the suco centroid
//           const sucoCentroid = turf.centroid(sucoFeature);
//           const submunicipalityFeature = submunicipalityData.features.find((sub) =>
//             turf.booleanPointInPolygon(sucoCentroid, sub)
//           );
//           if (submunicipalityFeature && submunicipalityFeature.properties) {
//             submunicipalityName = submunicipalityFeature.properties.ADM2 || "Unknown";

//             // Find municipality containing the submunicipality centroid
//             const subCentroid = turf.centroid(submunicipalityFeature);
//             const municipalityFeature = municipalityData.features.find((mun) =>
//               turf.booleanPointInPolygon(subCentroid, mun)
//             );
//             if (municipalityFeature && municipalityFeature.properties) {
//               municipalityName = municipalityFeature.properties.ADM1 || "Unknown";
//             }
//           }
//         }

//         return {
//           suco: sucoName,
//           submunicipality: submunicipalityName,
//           municipality: municipalityName,
//           risk: hotspot.properties.risk || "Unknown",
//         };
//       });
//       setHotspotTable(tableData);
//     }
//   }, [hotspotData, sucoData, submunicipalityData, municipalityData]);

//   // Styles for GeoJSON layers
//   const hotspotStyle = {
//     color: "red",
//     weight: 2,
//     fillColor: "red",
//     fillOpacity: 0.9,
//   };

//   const municipalityStyle = {
//     color: "blue",
//     weight: 2,
//     fillColor: "blue",
//     fillOpacity: 0.0,
//   };

//   const submunicipalityStyle = {
//     color: "green",
//     weight: 2,
//     fillColor: "green",
//     fillOpacity: 0.0,
//   };

//   const sucoStyle = {
//     color: "black",
//     weight: 1,
//     fillColor: "gray",
//     fillOpacity: 0.1,
//   };

//   // Handle feature interactions
//   const onEachHotspotFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `
//         <b>Hotspot</b><br>
//         ID: ${feature.id || "Unknown"}<br>
//         Risk: ${feature.properties.risk || "Unknown"}<br>
//         Count: ${feature.properties.count || "Unknown"}
//       `;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachMunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSubmunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSucoFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   return (
//     <div className="hotspot-container">
//       <MapContainer
//         center={center}
//         zoom={INITIAL_VIEW_STATE.zoom}
//         style={{ height: "82vh", width: "100%" }}
//       >
//         <TileLayer
//             url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
//             attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
//             />

//         <LayersControl position="topright">
//           {hotspotData && (
//             <LayersControl.Overlay name="Hotspots" checked>
//               <GeoJSON
//                 data={hotspotData}
//                 style={hotspotStyle}
//                 onEachFeature={onEachHotspotFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//           {municipalityData && (
//             <LayersControl.Overlay name="Municipalities">
//               <GeoJSON
//                 data={municipalityData}
//                 style={municipalityStyle}
//                 onEachFeature={onEachMunicipalityFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//           {submunicipalityData && (
//             <LayersControl.Overlay name="Submunicipalities">
//               <GeoJSON
//                 data={submunicipalityData}
//                 style={submunicipalityStyle}
//                 onEachFeature={onEachSubmunicipalityFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//           {sucoData && (
//             <LayersControl.Overlay name="Sucos">
//               <GeoJSON
//                 data={sucoData}
//                 style={sucoStyle}
//                 onEachFeature={onEachSucoFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//         </LayersControl>

//         <div
//           style={{
//             position: 'absolute',
//             bottom: '2px',
//             right: '2px',
//             background: 'white',
//             padding: '10px',
//             border: '1px solid #ccc',
//             zIndex: 1000,
//           }}
//         >
//           <LegendItem color="rgba(255, 0, 0, 1)" label="Hotspots" />
//         </div>

//       </MapContainer>

//       {/* Hotspot Data Table */}
//       <div className="hotspot-table-container">
//         <h3>Hotspot Data</h3>
//         <table>
//           <thead>
//             <tr>
//               <th>Suco</th>
//               <th>Submunicipality</th>
//               <th>Municipality</th>
//               <th>Risk Level</th>
//             </tr>
//           </thead>
//           <tbody>
//             {hotspotTable.map((row, index) => (
//               <tr key={index}>
//                 <td>{row.suco}</td>
//                 <td>{row.submunicipality}</td>
//                 <td>{row.municipality}</td>
//                 <td>{row.risk}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// const LegendItem = ({ color, label }) => (
//     <div style={{ marginBottom: '5px' }}>
//       <span
//         style={{
//           display: 'inline-block',
//           width: '20px',
//           height: '10px',
//           background: color,
//           marginRight: '5px',
//         }}
//       ></span>
//       {label}
//     </div>
//   );
  

// export default Hotspot;




// import React, { useEffect, useState, useRef } from "react";
// import { MapContainer, TileLayer, GeoJSON, LayersControl } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import * as turf from "@turf/turf";
// import domtoimage from "dom-to-image";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";

// const translations = {
//   en: {
//     title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
//     warningTitle: "Hotspot Advisory",
//     advisoryNumber: "Advisory number:",
//     issuedBy: "Issued by:",
//     issuedAt: "Date & Time:",
//     overview: "OVERVIEW",
//     highRiskWarning: "A forecast has been issued for high fire risk hotspots in several sucos within [highRiskMunicipalities]. Immediate precautions are recommended to prevent fire outbreaks.",
//     mapHeading: "FIRE HOTSPOT RISK MAP",
//     tableHeaders: ["Suco", "Submunicipality", "Municipality", "Risk Level"],
//     generalAdvisory: "GENERAL ADVISORY",
//     advisoryIntro: "The Disaster Risk Reduction Decision Support System advises that people should:",
//     advisoryPoints: [
//       "Avoid open burning in high-risk areas.",
//       "Clear dry vegetation and debris around homes and community areas.",
//       "Ensure firefighting equipment is accessible and functional.",
//       "Avoid activities that may spark fires, such as using machinery in dry conditions.",
//       "Report any fire outbreaks immediately to local authorities.",
//       "For emergency assistance, contact the local disaster management authorities.",
//     ],
//     noteLabel: "Note:",
//     noteText: "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
//     footer: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
//     page: "Page [i] of [pageCount]",
//   },
//   tetum: {
//     title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
//     warningTitle: "Aviso Kona-ba Hotspot",
//     advisoryNumber: "Númeru Aviso:",
//     issuedBy: "Ema-husik husi:",
//     issuedAt: "Data no Oras:",
//     overview: "VISAUN JERAL",
//     highRiskWarning: "Forescast ida ema-husik ona kona-ba risku foho altus iha suco balun iha [highRiskMunicipalities]. Rekomenda prevensaun imediata atu prevene foho.",
//     mapHeading: "MAPA RISKU HOTSPOT FOHO",
//     tableHeaders: ["Suco", "Submunisípiu", "Munisípiu", "Nivel Risku"],
//     generalAdvisory: "KONSELLU JERAL",
//     advisoryIntro: "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella katak ema sira tenki:",
//     advisoryPoints: [
//       "Evita sunu abertu iha área ho risku altus.",
//       "Hadi’a ai-manas no lixu iha área uma no komunidade.",
//       "Garante ekipamentu kombate foho acessível no funsional.",
//       "Evita atividade ne’ebé bele hamos foho, hanesan uza makina iha kondisaun sekas.",
//       "Relata foho ruma imediatamente ba autoridade lokál.",
//       "Ba asisténsia emerjénsia, kontaktu autoridade jestaun dezastre lokál.",
//     ],
//     noteLabel: "Nota:",
//     noteText: "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
//     footer: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
//     page: "Pajina [i] husi [pageCount]",
//   },
// };

// // Risk level translations
// const riskLevelTranslations = {
//   en: {
//     3: "High Risk",
//   },
//   tetum: {
//     3: "Risku Altus",
//   },
// };

// // Helper function to load images
// const loadImage = (src) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = "Anonymous";
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = src;
//   });
// };

// const generatePdfWithImage = async (dataUrl, hotspotTable, municipalityData, language = "en") => {
//     try {
//       const pdf = new jsPDF("portrait", "mm", "a4");
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       const sideMargin = 10; // Margin for left and right
//       const topMargin = 10; // 20mm top margin for new pages
//       const footerHeight = 10; // 10mm reserved for footer
//       const marginBottom = 10; // Margin above footer
//       const availablePageHeight = pageHeight - topMargin - footerHeight - marginBottom; // 297 - 20 - 10 - 10 = 257mm
//       let currentY = sideMargin; // Start with sideMargin for first page
//       const defaultSpacing = 5;
  
//       const t = translations[language];
//       const riskT = riskLevelTranslations[language];

//     // Load banner image
// let bannerImage;
// try {
//   bannerImage = await loadImage("/pdf/banner.png");
// } catch (error) {
//   console.warn("Failed to load banner.png:", error);
//   bannerImage = null;
// }

// // Add banner as header
// const bannerHeight = 20; // Height in mm (adjust as needed)
// const bannerWidth = pageWidth - 2 * sideMargin; // Span page width minus margins
// if (bannerImage) {
//   pdf.addImage(
//     bannerImage,
//     "PNG",
//     sideMargin,
//     topMargin,
//     bannerWidth,
//     bannerHeight
//   );
// }

// // Update currentY to start content below the banner
// currentY = topMargin + bannerHeight + 5; // 5mm gap below banner
  
//       // Add warning title
//       pdf.setFontSize(13);
//       pdf.setTextColor(255, 0, 0);
//       if (currentY + 10 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.text(t.warningTitle, pageWidth / 2, currentY, { align: "center" });
//       pdf.setTextColor(0, 0, 0);
//       currentY += 10;
  
//       // Format date in Asia/Dili timezone
//       const now = new Date();
//       const formattedDate = new Intl.DateTimeFormat("en-GB", {
//         timeZone: "Asia/Dili",
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       }).format(now);
  
//       const [datePart, timePartRaw] = formattedDate.split(", ");
//       const [day, month, year] = datePart.split("/");
//       const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
//       const [_, hour, minute, second, period] = timeMatch;
//       const formattedTimorDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;
  
//       // Add advisory details
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "normal");
//       if (currentY + 6 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.text(`${t.advisoryNumber} 1`, sideMargin, currentY);
//       currentY += 6;
//       if (currentY + 6 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.text(`${t.issuedBy} Department of Meteorology`, sideMargin, currentY);
//       currentY += 6;
//       const issuedAtText = `${t.issuedAt} ${formattedTimorDate}`;
//       const issuedAtLines = pdf.splitTextToSize(issuedAtText, pageWidth - 2 * sideMargin);
//       issuedAtLines.forEach((line) => {
//         if (currentY + 6 > availablePageHeight) {
//           pdf.addPage();
//           currentY = topMargin;
//         }
//         pdf.text(line, sideMargin, currentY);
//         currentY += 6;
//       });
//       currentY += 6;
  
//       // Identify high-risk municipalities
//       const highRiskMunicipalities = [...new Set(
//         hotspotTable
//           .filter((row) => row.risk >= 3)
//           .map((row) => row.municipality)
//       )].join(", ") || (language === "en" ? "No high-risk areas identified" : "Laiha fatin ho risku altus identifika");
  
//       // OVERVIEW section
//       pdf.setFontSize(12);
//       pdf.setFont("helvetica", "bold");
//       if (currentY + 8 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.setFillColor(255, 255, 255);
//       pdf.rect(sideMargin, currentY - 4, pageWidth - 2 * sideMargin, 8, "F");
//       pdf.text(t.overview, sideMargin, currentY);
//       pdf.setTextColor(0, 0, 0);
//       currentY += 8;
  
//       // Warning message
//       const warningText = [t.highRiskWarning.replace("[highRiskMunicipalities]", highRiskMunicipalities)];
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "normal");
//       warningText.forEach((line) => {
//         const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
//         lines.forEach((splitLine) => {
//           if (currentY + 6 > availablePageHeight) {
//             pdf.addPage();
//             currentY = topMargin;
//           }
//           pdf.text(splitLine, sideMargin, currentY);
//           currentY += 6;
//         });
//         currentY += 2;
//       });
//       currentY += 5;
  
//       // MAP heading
//       pdf.setFontSize(12);
//       pdf.setFont("helvetica", "bold");
//       if (currentY + 8 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.setFillColor(255, 255, 255);
//       pdf.rect(sideMargin, currentY - 4, pageWidth - 2 * sideMargin, 8, "F");
//       pdf.text(t.mapHeading, sideMargin, currentY);
//       pdf.setTextColor(0, 0, 0);
//       currentY += 3;
  
//       // Add map image
//       if (dataUrl) {
//         const img = await loadImage(dataUrl);
//         const availableWidth = pageWidth - 2 * sideMargin;
//         const imgHeight = (img.height * availableWidth) / img.width;
  
//         if (currentY + imgHeight + defaultSpacing > availablePageHeight) {
//           pdf.addPage();
//           currentY = topMargin;
//         }
  
//         pdf.addImage(dataUrl, "PNG", sideMargin, currentY, availableWidth, imgHeight);
//         currentY += imgHeight + defaultSpacing;
//       } else {
//         console.warn("No map image provided for PDF");
//       }
//       currentY += 5;
  
//       // Prepare table data
//       const tableData = hotspotTable.map((row) => [
//         row.suco,
//         row.submunicipality,
//         row.municipality,
//         riskT[row.risk] || row.risk,
//       ]);
  
//       // Add table
//       if (currentY + 20 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       autoTable(pdf, {
//         startY: currentY,
//         head: [t.tableHeaders],
//         body: tableData,
//         theme: "grid",
//         headStyles: { fillColor: [0, 102, 204], halign: "center", fontStyle: "bold" },
//         styles: { fontSize: 9, cellPadding: 3 },
//         columnStyles: {
//           0: { cellWidth: 40 },
//           1: { cellWidth: 40 },
//           2: { cellWidth: 40 },
//           3: { cellWidth: 40 },
//         },
//         margin: { left: sideMargin, right: sideMargin },
//         didDrawPage: (data) => {
//           currentY = data.cursor.y + 10; // Update currentY after table
//         },
//       });
  
//       currentY += 5;
  
//       // GENERAL ADVISORY section
//       if (currentY + 12 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.setFontSize(12);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFillColor(255, 255, 255);
//       pdf.rect(sideMargin, currentY - 4, pageWidth - 2 * sideMargin, 8, "F");
//       pdf.text(t.generalAdvisory, sideMargin, currentY);
//       pdf.setTextColor(0, 0, 0);
//       currentY += 7;
  
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "normal");
//       if (currentY + 6 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.text(t.advisoryIntro, sideMargin, currentY);
//       currentY += 6;
  
//       // Advisory points
//       const advisoryPoints = t.advisoryPoints;
//       advisoryPoints.forEach((point) => {
//         const bullet = "•";
//         const bulletMargin = 6;
//         const maxLineWidth = pageWidth - 2 * sideMargin - bulletMargin;
//         const textX = sideMargin + 2;
//         const hangingIndentX = textX + 2;
  
//         const lines = pdf.splitTextToSize(point, maxLineWidth);
//         const sectionHeight = lines.length * 6 + 2;
  
//         if (currentY + sectionHeight > availablePageHeight) {
//           pdf.addPage();
//           currentY = topMargin;
//         }
  
//         lines.forEach((line, index) => {
//           if (index === 0) {
//             pdf.text(`${bullet} ${line}`, textX, currentY);
//           } else {
//             pdf.text(line, hangingIndentX, currentY);
//           }
//           currentY += 6;
//         });
//         currentY += 2;
//       });
  
//       currentY += 5;
  
//       // Add Note section
//       if (currentY + 12 > availablePageHeight) {
//         pdf.addPage();
//         currentY = topMargin;
//       }
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(t.noteLabel, sideMargin, currentY);
//       currentY += 6;
//       pdf.setFont("helvetica", "normal");
//       const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
//       noteLines.forEach((line) => {
//         if (currentY + 6 > availablePageHeight) {
//           pdf.addPage();
//           currentY = topMargin;
//         }
//         pdf.text(line, sideMargin, currentY);
//         currentY += 6;
//       });
  
//       // Add footer to all pages
//       const pageCount = pdf.internal.getNumberOfPages();
//       const footerYOffset = 5;
//       for (let i = 1; i <= pageCount; i++) {
//         pdf.setPage(i);
//         pdf.setFontSize(8);
//         pdf.text(
//           t.footer,
//           pageWidth / 2,
//           pageHeight - footerHeight + footerYOffset - 2,
//           { align: "center" }
//         );
//         pdf.text(
//           t.page.replace("[i]", i).replace("[pageCount]", pageCount),
//           pageWidth / 2,
//           pageHeight - footerHeight + footerYOffset + 3,
//           { align: "center" }
//         );
//       }
  
//       pdf.save("DRRDSS-Hotspot-Advisory.pdf");
//     } catch (error) {
//       console.error("Failed to generate PDF:", error);
//       throw error;
//     }
//   };

// const Hotspot = () => {
//   const [hotspotData, setHotspotData] = useState(null);
//   const [municipalityData, setMunicipalityData] = useState(null);
//   const [submunicipalityData, setSubmunicipalityData] = useState(null);
//   const [sucoData, setSucoData] = useState(null);
//   const [hotspotTable, setHotspotTable] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const containerRef = useRef(null);

//   const center = [-9.1742, 124.7275]; // Timor-Leste
//   const INITIAL_VIEW_STATE = {
//     zoom: 7.5,
//   };

//   // Fetch hotspot data
//   useEffect(() => {
//     fetch("/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson")
//       .then((response) => response.json())
//       .then((data) => setHotspotData(data))
//       .catch((error) => console.error("Error loading hotspot data:", error));
//   }, []);

//   // Fetch municipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm1_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setMunicipalityData(data))
//       .catch((error) => console.error("Error loading municipality data:", error));
//   }, []);

//   // Fetch submunicipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm2_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSubmunicipalityData(data))
//       .catch((error) => console.error("Error loading submunicipality data:", error));
//   }, []);

//   // Fetch suco data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm3_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSucoData(data))
//       .catch((error) => console.error("Error loading suco data:", error));
//   }, []);

//   // Process hotspot data to build the table
//   useEffect(() => {
//     if (hotspotData && sucoData && submunicipalityData && municipalityData) {
//       const tableData = hotspotData.features.map((hotspot) => {
//         const centroid = turf.centroid(hotspot);

//         let sucoName = "Unknown";
//         let submunicipalityName = "Unknown";
//         let municipalityName = "Unknown";

//         const sucoFeature = sucoData.features.find((suco) =>
//           turf.booleanPointInPolygon(centroid, suco)
//         );
//         if (sucoFeature && sucoFeature.properties) {
//           sucoName = sucoFeature.properties.ADM3 || "Unknown";

//           const sucoCentroid = turf.centroid(sucoFeature);
//           const submunicipalityFeature = submunicipalityData.features.find((sub) =>
//             turf.booleanPointInPolygon(sucoCentroid, sub)
//           );
//           if (submunicipalityFeature && submunicipalityFeature.properties) {
//             submunicipalityName = submunicipalityFeature.properties.ADM2 || "Unknown";

//             const subCentroid = turf.centroid(submunicipalityFeature);
//             const municipalityFeature = municipalityData.features.find((mun) =>
//               turf.booleanPointInPolygon(subCentroid, mun)
//             );
//             if (municipalityFeature && municipalityFeature.properties) {
//               municipalityName = municipalityFeature.properties.ADM1 || "Unknown";
//             }
//           }
//         }

//         return {
//           suco: sucoName,
//           submunicipality: submunicipalityName,
//           municipality: municipalityName,
//           risk: hotspot.properties.risk || "Unknown",
//         };
//       });
//       setHotspotTable(tableData);
//     }
//   }, [hotspotData, sucoData, submunicipalityData, municipalityData]);

//   // Generate report
//   const generateReport = async () => {
//     const containerElement = containerRef.current;
//     if (!containerElement || !hotspotTable.length) {
//       console.warn("Cannot generate report: container or hotspotTable missing");
//       alert("Cannot generate report: Data is missing.");
//       return;
//     }

//     const languagePrompt = window.prompt(
//       "Please select the language for Generating Report:\nOption 1: English\nOption 2: Tetum\n\nEnter 1 for English or 2 for Tetum:",
//       "1"
//     );

//     let language = "en";
//     if (languagePrompt === "2") {
//       language = "tetum";
//     } else if (languagePrompt !== "1") {
//       alert("Invalid selection. Defaulting to English.");
//     }

//     setLoading(true);
//     try {
//       const dataUrl = await domtoimage.toPng(containerElement, {
//         width: containerElement.offsetWidth,
//         height: containerElement.offsetHeight,
//         style: { background: "white" },
//         quality: 0.95,
//       });
//       await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, language);
//     } catch (error) {
//       console.error("Failed to capture image or generate PDF:", error);
//       alert("Failed to generate PDF. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Styles for GeoJSON layers
//   const hotspotStyle = {
//     color: "red",
//     weight: 2,
//     fillColor: "red",
//     fillOpacity: 0.9,
//   };

//   const municipalityStyle = {
//     color: "blue",
//     weight: 2,
//     fillColor: "blue",
//     fillOpacity: 0.0,
//   };

//   const submunicipalityStyle = {
//     color: "green",
//     weight: 2,
//     fillColor: "green",
//     fillOpacity: 0.0,
//   };

//   const sucoStyle = {
//     color: "black",
//     weight: 1,
//     fillColor: "gray",
//     fillOpacity: 0.1,
//   };

//   // Handle feature interactions
//   const onEachHotspotFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `
//         <b>Hotspot</b><br>
//         ID: ${feature.id || "Unknown"}<br>
//         Risk: ${feature.properties.risk || "Unknown"}<br>
//         Count: ${feature.properties.count || "Unknown"}
//       `;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachMunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSubmunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSucoFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   return (
//     <>
//     <button
//         onClick={generateReport}
//         disabled={loading}
//         className={`px-2 py-1 rounded hover:bg-blue-600 z-[1000] ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
//         style={{
//           backgroundColor: "blue",
//           color: "#333333",
//           marginBottom: "5px", 
//           marginLeft:"87%",
//           top: "0px",
//           right: "0px",
//           border: "none",
//         }}
//       >
//         {loading ? "Generating..." : "Generate Report"}
//       </button>
//     <div className="hotspot-container" ref={containerRef}>
      
//       <MapContainer
//         center={center}
//         zoom={INITIAL_VIEW_STATE.zoom}
//         style={{ height: "75vh", width: "100%" }}
//       >
//         <TileLayer
//           url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
//           attribution="Tiles © Esri — Esri, DeLorme, NAVTEQ"
//         />

//         <LayersControl position="topright">
//           {hotspotData && (
//             <LayersControl.Overlay name="Hotspots" checked>
//               <GeoJSON
//                 data={hotspotData}
//                 style={hotspotStyle}
//                 onEachFeature={onEachHotspotFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//           {municipalityData && (
//             <LayersControl.Overlay name="Municipalities">
//               <GeoJSON
//                 data={municipalityData}
//                 style={municipalityStyle}
//                 onEachFeature={onEachMunicipalityFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//           {submunicipalityData && (
//             <LayersControl.Overlay name="Submunicipalities">
//               <GeoJSON
//                 data={submunicipalityData}
//                 style={submunicipalityStyle}
//                 onEachFeature={onEachSubmunicipalityFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//           {sucoData && (
//             <LayersControl.Overlay name="Sucos">
//               <GeoJSON
//                 data={sucoData}
//                 style={sucoStyle}
//                 onEachFeature={onEachSucoFeature}
//               />
//             </LayersControl.Overlay>
//           )}
//         </LayersControl>

//         <div
//           style={{
//             position: "absolute",
//             bottom: "2px",
//             right: "2px",
//             background: "white",
//             padding: "10px",
//             border: "1px solid #ccc",
//             zIndex: 1000,
//           }}
//         >
//           <LegendItem color="rgba(255, 0, 0, 1)" label="Hotspots" />
//         </div>
//       </MapContainer>

//       {/* Hotspot Data Table */}
//       {/* <div className="hotspot-table-container">
//         <h3>Hotspot Data</h3>
//         <table>
//           <thead>
//             <tr>
//               <th>Suco</th>
//               <th>Submunicipality</th>
//               <th>Municipality</th>
//               <th>Risk Level</th>
//             </tr>
//           </thead>
//           <tbody>
//             {hotspotTable.map((row, index) => (
//               <tr key={index}>
//                 <td>{row.suco}</td>
//                 <td>{row.submunicipality}</td>
//                 <td>{row.municipality}</td>
//                 <td>{row.risk}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div> */}
//     </div>
//     </>
//   );
// };

// const LegendItem = ({ color, label }) => (
//   <div style={{ marginBottom: "5px" }}>
//     <span
//       style={{
//         display: "inline-block",
//         width: "20px",
//         height: "10px",
//         background: color,
//         marginRight: "5px",
//       }}
//     ></span>
//     {label}
//   </div>
// );

// export default Hotspot;




// **********************************imp


// import React, { useEffect, useState, useRef } from "react";
// import { MapContainer, TileLayer, GeoJSON, LayersControl, useMap } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import * as turf from "@turf/turf";
// import domtoimage from "dom-to-image";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import { FaCircleInfo } from "react-icons/fa6";


// // Risk level translations

// const translations = {
//   en: {
//     title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
//     warningTitle: "Fire Hotspots Advisory for Timor-Leste",
//     advisoryNumber: "Advisory number: ",
//     issuedBy: "Issued by:",
//     issuedAt: "Date & Time:",
//     overview: "Overview",
//     highRiskWarning: "A forecast has been issued for high fire risk hotspots in several sucos within [highRiskMunicipalities]. Immediate precautions are recommended to prevent fire outbreaks.",
//     mapHeading: "Fire Hotspot Risk Map",
//     tableHeaders: ["Municipality", "Sub-Municipality", "Suco", "Risk Level"],
//     generalAdvisory: "General Advisory",
//     advisoryIntro: "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and prevent fire outbreaks:",
//     advisoryTableHeaders: ["Type", "Advisory"], // New header for advisory table
//     advisoryPoints: [
//       {
//         type: "Do's",
//         points: [
//           "Secure flammable materials away from heat-prone areas.",
//           "Ensure any outdoor fire or heat-producing activity is fully extinguished before leaving."
//         ]
//       },
//       {
//         type: "Don'ts",
//         points: [
//           "Do not light fires or burn waste near vegetation or dry areas.",
//           "Do not engage in open burning activities during high heat periods.",
//           "Avoid entering high-risk areas without proper protective gear or local clearance."
//         ]
//       },
//       {
//         type: "Prevention and Preparedness",
//         points: [
//           "Keep emergency contact numbers of fire services and local authorities easily accessible.",
//           "Report any visible smoke, fire, or abnormal heat activity immediately.",
//           "Avoid outdoor activities that may trigger sparks or fires, such as welding or fireworks near dry vegetation.",
//           "Use lanterns, stoves, and heaters with caution in high-risk zones. Ensure equipment is cool before refueling.",
//           "Dispose of smoking materials like cigarettes safely and away from dry areas.",
//           "Do not burn agricultural, industrial, or municipal waste near hotspot regions.",
//           "Prepare and maintain defensible space around homes in at-risk zones by clearing dry debris and combustibles.",
//           "Ensure availability of emergency kits and pre-plan evacuation routes.",
//           "Conduct preparedness drills regularly and identify safe zones in your community."
//         ]
//       },
//       {
//         type: "Evacuation in Case of Extreme Heat or Fire Hotspot Escalation",
//         points: [
//           "Evacuate immediately upon advisories from local authorities or emergency services.",
//           "Protect yourself from heat exposure and possible airborne particles.",
//           "Secure your animals and assist vulnerable individuals during evacuation."
//         ]
//       },
//       {
//         type: "Before Leaving Your House",
//         points: [
//           "Remove all combustible items like gas cylinders, firewood, and dry waste from your surroundings.",
//           "Seal windows, vents, and doors to minimize smoke or heat intrusion.",
//           "Store water in large containers to use in case of emergency cooling.",
//           "Trim dry plants and clean debris around your property to reduce ignition risk.",
//           "Inspect and clean rooftops, gutters, and drainage areas regularly.",
//           "Dampen roofs and exterior walls if advised by emergency services during high-risk alerts."
//         ]
//       },
//       {
//         type: "If Exposed to a Hotspot While Outdoors",
//         points: [
//           "Avoid attempting to outrun fire or heat. Seek refuge in a cleared, low-vegetation area.",
//           "Cover your nose and mouth with a wet cloth to reduce smoke inhalation risk.",
//           "Use water, soil, or nonflammable materials to shield yourself if surrounded by heat or fire."
//         ]
//       },
//       {
//         type: "If Sheltering at Home During a Heat Alert or Hotspot Activation",
//         points: [
//           "Stay calm and indoors. Seal your home to prevent heat and smoke entry.",
//           "Avoid opening hot doors — it may indicate fire or intense heat on the other side.",
//           "Monitor official updates for when it's safe to evacuate or step out."
//         ]
//       },
//       {
//         type: "If Caught in a Vehicle in a Hotspot-Affected Area",
//         points: [
//           "Stay inside the vehicle — it offers better protection than open space.",
//           "Keep windows and air vents closed to avoid smoke and heat exposure.",
//           "Drive cautiously with headlights on and remain alert to surroundings.",
//           "If stopping, park away from vegetation and turn off the engine.",
//           "Stay low inside the vehicle and cover yourself with nonflammable material."
//         ]
//       }
//     ],
//     noteLabel: "Note:",
//     noteText: "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
//     footer: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
//     page: "Page [i] of [pageCount]",
//   },
//   tetum: {
//     title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
//     warningTitle: "Avisu kona ba Rai Manas iha Timor-Leste",
//     advisoryNumber: "Númeru Aviso:",
//     issuedBy: "Ema-husik husi:",
//     issuedAt: "Data no Oras:",
//     overview: "VISAUN JERAL",
//     highRiskWarning: "Forescast ida ema-husik ona kona-ba risku foho altus iha suco balun iha [highRiskMunicipalities]. Rekomenda prevensaun imediata atu prevene foho.",
//     mapHeading: "MAPA RISKU HOTSPOT FOHO",
//     tableHeaders: ["Munisípiu", "Sub-munisípiu","Suco", "Nivel Risku"],
//     generalAdvisory: "KONSELLU JERAL",
//     advisoryIntro: "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no prevene foho:",
//     advisoryTableHeaders: ["Tipu", "Konsellu"], // New header for advisory table
//     advisoryPoints: [
//       {
//         type: "Diak Halo",
//         points: [
//           "Tau hela materiál sira ne'ebé bele haksolok fatin hela toos no manas.",
//           "Konfirma katak hela-fatin ne'ebé manas ka iha api, sei la iha risku fatin molok ita halai."
//         ]
//       },
//       {
//         type: "Labele Halo",
//         points: [
//           "Labele sunu ai-ruin ka lixu besik toos ka fatin matak.",
//           "Labele halo sunu iha loron ne'ebé manas tebes.",
//           "Labele tama iha fatin risku boot tan manas boot la'ós ho proteksaun loos ka klaru husi autoridade lokal."
//         ]
//       },
//       {
//         type: "Prevensaun no Preparasaun",
//         points: [
//           "Tau hela numeru kontaktu emergencia hosi servisu bombeiru no autoridade lokal.",
//           "Hatete lalais ba autoridade se haree sukun, api, ka manas boot ne'ebé la normal.",
//           "Labele halo atividade iha liur ne'ebé bele halo iskra ka api, hanesan soldadura ka fogu d'artifísiu besik ai matak.",
//           "Uza lanterna, fogão, no aparato manas ho atensaun iha fatin manas. Labele tau gasolina antes ne'ebé aparatu cool.",
//           "Hamoos sigaru, fósforu, no materiál fumar iha fatin ne'ebé seguru, labele hikas iha fatin matak.",
//           "Labele sunu restu agrikultura, indústria ka lixu municipal besik hotspot.",
//           "Hamoos ai-ruin matak no materiál haksolok iha zona risku, prepara área seguransa iha entorno uma.",
//           "Prepara hela kit emergencia no buat sira ne'ebé importante ba evacuasaun.",
//           "Halo simulasaun evacuasaun no hatene fatin seguransa iha komunidade."
//         ]
//       },
//       {
//         type: "Evakuasaun iha tempu manas ka eskalasaun hotspot",
//         points: [
//           "Sai hela fatin tan dehan hosi autoridade lokal ka servisu emergencia.",
//           "Proteje-an hosi manas tebes no partículas iha ar.",
//           "Toman konta animal sira no ajuda ema matak ka ema ne'ebé iha nesesidade espesiál."
//         ]
//       },
//       {
//         type: "Molok Sai husi Uma",
//         points: [
//           "Taka no hasai buat hotu ne'ebé haksolok hanesan botija gas, ai-ruin, no lixu matak iha entorno uma.",
//           "Taka janela, ventilasaun no odamatan atu prevene fumaça ka manas tama.",
//           "Tau bee iha vasilha boot atu uza ba manan manas ka fumaça.",
//           "Kose ai-ruin matak no halo limpu zona iha nia sorin uma.",
//           "Hamoos telhado, kalha no fatin saluran bee.",
//           "Tau bee iha telhado, parede no ai sira iha sorin uma karik iha alerta hosi autoridade."
//         ]
//       },
//       {
//         type: "Se Ita iha Liur iha Fatin Hotspot",
//         points: [
//           "Labele halai atu la'o husi api. Bolu hela iha fatin ne'ebé matak no buka área klaru.",
//           "Kobre-an ho kanuru molik atu prevene fumaça tama iha matan no anin.",
//           "Uza bee, rai, ka materiál ne'ebé la bele sunu atu proteje-an se iha risku boot iha fatin."
//         ]
//       },
//       {
//         type: "Se Ita iha Uma Durante Alerta Hotspot",
//         points: [
//           "Tuir diak, hela iha uma. Taka buat hotu atu prevene fumaça ka manas tama.",
//           "Se odamatan manas tebes, labele taka tan bele iha api iha fatin seluk.",
//           "Tuir informasaun ofisiál ba tempu ne'ebé seguru atu sai ka evacuate."
//         ]
//       },
//       {
//         type: "Se Ita iha Karreta iha Fatin Hotspot",
//         points: [
//           "Hela iha laran karreta — liu seguru liu dukur iha liur.",
//           "Taka janela no ventilasaun atu prevene fumaça ka manas tama.",
//           "La'o ho kuidadu no laran moris iha luz karreta.",
//           "Se presiza para: para iha fatin ne'ebé laduun iha vegetasaun, taka motor.",
//           "Hela iha laran karreta no tuun ba rai.",
//           "Kobre-an ho ropa ka materiál ne'ebé la bele sunu."
//         ]
//       }
//     ],

//     noteLabel: "Nota:",
//     noteText: "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
//     footer: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
//     page: "Pajina [i] husi [pageCount]",
//   },
// };

// // Risk level translations
// const riskLevelTranslations = {
//   en: { 3: "High Risk" },
//   tetum: { 3: "Risku Altus" },
// };


// // Helper function to load images
// const loadImage = (src) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = "Anonymous";
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = src;
//   });
// };

// // Helper function to add banner to a page
// const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
//   const bannerHeight = 20; // Height in mm
//   const bannerWidth = pageWidth - 2 * sideMargin; // Span page width minus margins
//   if (bannerImage) {
//     pdf.addImage(
//       bannerImage,
//       "PNG",
//       sideMargin,
//       topMargin,
//       bannerWidth,
//       bannerHeight
//     );
//   }
//   return topMargin + bannerHeight + 5; // Return new currentY (5mm gap)
// };

// const generatePdfWithImage = async (dataUrl, hotspotTable, municipalityData, language = "en") => {
//   try {
//     const pdf = new jsPDF("portrait", "mm", "a4");
//     const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm
//     const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
//     const sideMargin = 10;
//     const topMargin = 10;
//     const footerHeight = 10;
//     const marginBottom = 10;
//     const bannerHeight = 20; // Assumed banner height
//     const headerHeight = topMargin + bannerHeight + 5; // 35 mm (10 + 20 + 5)
//     const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom; // ~242 mm
//     let currentY;

//     const t = translations[language];
//     const riskT = riskLevelTranslations[language];

//     // Load banner image based on language
//     let bannerImage;
//     const bannerPath = language === "en" ? "/pdf/banner.png" : "/pdf/tetumbanner.png";
//     try {
//       bannerImage = await loadImage(bannerPath);
//     } catch (error) {
//       console.warn(`Failed to load ${bannerPath}:`, error);
//       bannerImage = null;
//     }

//     // Helper function to add page with header
//     const addPageWithHeader = () => {
//       pdf.addPage();
//       return addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     };

//     // Add banner to first page
//     currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     currentY += 5;

//     // Add warning title
//     pdf.setFont('helvetica','bold');
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 0, 0);
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.text(t.warningTitle, pageWidth / 2, currentY, { align: "center" });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 10;

//     // Format date in Asia/Dili timezone
//     const now = new Date();
//     const formattedDate = new Intl.DateTimeFormat("en-GB", {
//       timeZone: "Asia/Dili",
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     }).format(now);

//     const [datePart, timePartRaw] = formattedDate.split(", ");
//     const [day, month, year] = datePart.split("/");
//     const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
//     const [_, hour, minute, second, period] = timeMatch;
//     const formattedTimorDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;

// pdf.setFontSize(10);

//     // Ensure enough space, else add page
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }

//     // Prepare left and right text with bold labels
//     pdf.setFont('helvetica', 'bold');
//     const advisoryNumberLabel = t.advisoryNumber;
//     pdf.text(advisoryNumberLabel, sideMargin, currentY);
//     pdf.setFont('helvetica', 'normal');
//     pdf.text(' 1', sideMargin + pdf.getTextWidth(advisoryNumberLabel) + 2, currentY);
//     pdf.setFont('helvetica', 'bold');
//     const issuedAtLabel = t.issuedAt;
//     const rightText = `${issuedAtLabel} ${formattedTimorDate}`;
//     const rightTextWidth = pdf.getTextWidth(rightText);
//     const rightX = pageWidth - sideMargin - rightTextWidth;
//     pdf.text(issuedAtLabel, rightX, currentY);
//     pdf.setFont('helvetica', 'normal');
//     pdf.text(formattedTimorDate, rightX + pdf.getTextWidth(issuedAtLabel) + 2, currentY);
//     currentY += 6;

//     // Issued by
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont('helvetica','bold');
//     const issuedByLabel = t.issuedBy;
//     pdf.text(issuedByLabel, sideMargin, currentY);
//     pdf.setFont('helvetica','normal');
//     pdf.text('Department of Meteorology', sideMargin + pdf.getTextWidth(issuedByLabel) + 2, currentY);
//     currentY += 6;

//     currentY += 5;

//     // Identify high-risk municipalities
//     const highRiskMunicipalities = [...new Set(
//       hotspotTable
//         .filter((row) => row.risk >= 3)
//         .map((row) => row.municipality)
//     )].join(", ") || (language === "en" ? "No high-risk areas identified" : "Laiha fatin ho risku altus identifika");

//     currentY += 5;

//     // OVERVIEW section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239); // Background color (light blue)
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
//     pdf.setTextColor(0, 0, 0); // Black text
//     pdf.text(t.overview, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
//     pdf.setTextColor(0, 0, 0); // Reset text color
//     currentY += 10;

//     // Warning message
//     const warningText = [t.highRiskWarning.replace("[highRiskMunicipalities]", highRiskMunicipalities)];
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "normal");
//     warningText.forEach((line) => {
//       const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
//       lines.forEach((splitLine) => {
//         if (currentY + 6 > availablePageHeight + headerHeight) {
//           currentY = addPageWithHeader();
//         }
//         pdf.text(splitLine, sideMargin, currentY);
//         currentY += 6;
//       });
//       currentY += 2;
//     });
//     currentY += 5;

//     currentY += 2;

//     // MAP heading
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239); // Background color (light blue)
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
//     pdf.setTextColor(0, 0, 0); // Black text
//     pdf.text(t.mapHeading, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
//     pdf.setTextColor(0, 0, 0); // Reset text color
//     currentY += 5;

//     // Add map image
//     if (dataUrl) {
//       const img = await loadImage(dataUrl);
//       const availableWidth = pageWidth - 2 * sideMargin;
//       const imgHeight = (img.height * availableWidth) / img.width;

//       if (currentY + imgHeight + 5 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }

//       pdf.addImage(dataUrl, "PNG", sideMargin, currentY, availableWidth, imgHeight);
//       currentY += imgHeight + 5;
//     } else {
//       console.warn("No map image provided for PDF");
//     }
//     currentY += 5;

//     // Prepare table data
//     const tableData = hotspotTable.map((row) => [
//       row.municipality,
//       row.submunicipality,
//       row.suco,
//       riskT[row.risk] || row.risk,
//     ]);

//     // Add table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.tableHeaders],
//       body: tableData,
//       theme: "grid",
//       headStyles: { fillColor: [225, 232, 242], halign: "left", fontStyle: "bold", textColor: "black" },
//       styles: { fontSize: 9, cellPadding: 3 },
//       columnStyles: {
//         0: { cellWidth: 40 },
//         1: { cellWidth: 40 },
//         2: { cellWidth: 40 },
//         3: { cellWidth: 40 },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         // Add banner before drawing page
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });

//     currentY += 5;

//     // GENERAL ADVISORY section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont('helvetica', 'bold');
//     pdf.setFillColor(202, 217, 239);
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(t.generalAdvisory, sideMargin + 2, currentY - 1, { align: 'left' });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 7;

//     currentY += 5;

//     // Add advisory intro
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "normal");
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     const introLines = pdf.splitTextToSize(t.advisoryIntro, pageWidth - 2 * sideMargin);
//     introLines.forEach((line) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });

//     currentY += 5;

//     // Prepare table data for advisory with bullet points
//     const advisoryTableData = t.advisoryPoints.map((category) => [
//       category.type,
//       category.points.map((point) => `• ${point}`).join("\n") // Prepend bullet to each point
//     ]);

//     // Add advisory table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.advisoryTableHeaders], // ["Type", "Advisory"]
//       body: advisoryTableData,
//       theme: "grid",
//       headStyles: {
//         fillColor: [225, 232, 242], // Match hotspot table header color
//         halign: "left",
//         fontStyle: "bold",
//         textColor: 'black', // White text for header
//       },
//       styles: {
//         fontSize: 9,
//         cellPadding: { top: 3, right: 3, bottom: 3, left: 5 }, // Slightly more left padding for bullet alignment
//         overflow: "linebreak", // Allow text to wrap within cells
//         lineHeight: 1.2, // Adjust line spacing for better readability
//       },
//       columnStyles: {
//         0: { cellWidth: 40, halign: "left" }, // Type column
//         1: { cellWidth: pageWidth - 2 * sideMargin - 40, halign: "left" }, // Advisory column
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         // Add banner before drawing page
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });

//     currentY += 5;

//     // Add Note section
//     if (currentY + 12 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(t.noteLabel, sideMargin, currentY);
//     currentY += 6;
//     pdf.setFont("helvetica", "normal");
//     const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
//     noteLines.forEach((line) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });
//     currentY += 4; // Add padding after the section

//     currentY += 12;

//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont('helvetica', 'bold');
//     pdf.text('*****', (pageWidth - pdf.getTextWidth('*****')) / 2, currentY);
//     currentY += 6;
//     pdf.setFont('helvetica', 'normal');

//     // Add footer to all pages
//     const pageCount = pdf.internal.getNumberOfPages();
//     const footerYOffset = 5;
//     for (let i = 1; i <= pageCount; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(8);
//       pdf.text(
//         t.footer,
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset - 2,
//         { align: "center" }
//       );
//       pdf.text(
//         t.page.replace("[i]", i).replace("[pageCount]", pageCount),
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset + 3,
//         { align: "center" }
//       );
//     }

//     pdf.save("DRRDSS-Hotspot-Advisory.pdf");
//   } catch (error) {
//     console.error("Failed to generate PDF:", error);
//     throw error;
//   }
// };

// const InfoButton = ({ setInfo }) => {
//   useMap(); // Optional: only needed if you want to interact with the map
//   return (
//     <div
//       style={{
//         position: "absolute",
//         bottom: "10px",
//         left: "10px",
//         padding: "8px",
//         borderRadius: "5px",
//         fontSize: "15px",
//         cursor: "pointer",
//         zIndex: 999,
//       }}
//       onMouseEnter={() => setInfo(true)}
//       onMouseLeave={() => setInfo(false)}
//     >
//       <FaCircleInfo />
//     </div>
//   );
// };

// const Hotspot = () => {
//   const [hotspotData, setHotspotData] = useState(null);
//   const [municipalityData, setMunicipalityData] = useState(null);
//   const [submunicipalityData, setSubmunicipalityData] = useState(null);
//   const [sucoData, setSucoData] = useState(null);
//   const [hotspotTable, setHotspotTable] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const containerRef = useRef(null);
//   const [info, setInfo] = useState(false);
//   const [showLanguageModal, setShowLanguageModal] = useState(false);

//   const center = [-8.7742, 125.675]; // Timor-Leste
//   const INITIAL_VIEW_STATE = {
//     zoom: 8.5,
//   };

//   // Fetch hotspot data
//   useEffect(() => {
//     fetch("/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson")
//       .then((response) => response.json())
//       .then((data) => setHotspotData(data))
//       .catch((error) => console.error("Error loading hotspot data:", error));
//   }, []);

//   // Fetch municipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm1_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setMunicipalityData(data))
//       .catch((error) => console.error("Error loading municipality data:", error));
//   }, []);

//   // Fetch submunicipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm2_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSubmunicipalityData(data))
//       .catch((error) => console.error("Error loading submunicipality data:", error));
//   }, []);

//   // Fetch suco data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm3_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSucoData(data))
//       .catch((error) => console.error("Error loading suco data:", error));
//   }, []);

//   // Process hotspot data to build the table
//   useEffect(() => {
//     if (hotspotData && sucoData && submunicipalityData && municipalityData) {
//       const tableData = hotspotData.features.map((hotspot) => {
//         const centroid = turf.centroid(hotspot);

//         let sucoName = "Unknown";
//         let submunicipalityName = "Unknown";
//         let municipalityName = "Unknown";

//         const sucoFeature = sucoData.features.find((suco) =>
//           turf.booleanPointInPolygon(centroid, suco)
//         );
//         if (sucoFeature && sucoFeature.properties) {
//           sucoName = sucoFeature.properties.ADM3 || "Unknown";

//           const sucoCentroid = turf.centroid(sucoFeature);
//           const submunicipalityFeature = submunicipalityData.features.find((sub) =>
//             turf.booleanPointInPolygon(sucoCentroid, sub)
//           );
//           if (submunicipalityFeature && submunicipalityFeature.properties) {
//             submunicipalityName = submunicipalityFeature.properties.ADM2 || "Unknown";

//             const subCentroid = turf.centroid(submunicipalityFeature);
//             const municipalityFeature = municipalityData.features.find((mun) =>
//               turf.booleanPointInPolygon(subCentroid, mun)
//             );
//             if (municipalityFeature && municipalityFeature.properties) {
//               municipalityName = municipalityFeature.properties.ADM1 || "Unknown";
//             }
//           }
//         }

//         return {
//           suco: sucoName,
//           submunicipality: submunicipalityName,
//           municipality: municipalityName,
//           risk: hotspot.properties.risk || "Unknown",
//         };
//       });
//       setHotspotTable(tableData);
//     }
//   }, [hotspotData, sucoData, submunicipalityData, municipalityData]);


//   const handleLanguageSelection = async (language) => {
//     setShowLanguageModal(false);
//     const containerElement = containerRef.current;
//     if (!containerElement || !hotspotTable.length) {
//       console.warn("Cannot generate report: container or hotspotTable missing");
//       alert("Cannot generate report: Data is missing.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const dataUrl = await domtoimage.toPng(containerElement, {
//         width: containerElement.offsetWidth,
//         height: containerElement.offsetHeight,
//         style: { background: "white" },
//         quality: 0.95,
//       });
//       await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, language);
//     } catch (error) {
//       console.error("Failed to capture image or generate PDF:", error);
//       alert("Failed to generate PDF. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const generateReport = () => {
//     setShowLanguageModal(true);
//   };


//   // Styles for GeoJSON layers
//   const hotspotStyle = {
//     color: "red",
//     weight: 2,
//     fillColor: "red",
//     fillOpacity: 0.9,
//   };

//   const municipalityStyle = {
//     color: "black",
//     weight: 0.5,
//     fillColor: "blue",
//     fillOpacity: 0.0,
//   };

//   const submunicipalityStyle = {
//     color: "green",
//     weight: 2,
//     fillColor: "green",
//     fillOpacity: 0.0,
//   };

//   const sucoStyle = {
//     color: "black",
//     weight: 1,
//     fillColor: "gray",
//     fillOpacity: 0.1,
//   };

//   // Handle feature interactions
//   const onEachHotspotFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `
//         <b>Hotspot</b><br>
//         ID: ${feature.id || "Unknown"}<br>
//         Risk: ${feature.properties.risk || "Unknown"}<br>
//         Count: ${feature.properties.count || "Unknown"}
//       `;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachMunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSubmunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSucoFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   return (
//     <>
//       <button
//         onClick={generateReport}
//         disabled={loading}
//         style={{
//           padding: "4px 6px",
//           borderRadius: "6px",
//           backgroundColor: "blue",
//           color: "#333333",
//           marginBottom: "5px",
//           marginLeft: "87%",
//           top: "0px",
//           right: "0px",
//           border: "none",
//         }}
//       >
//         {loading ? "Generating..." : "Generate Report"}
//       </button>
//       {showLanguageModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "flex-start",
//             paddingTop: "80px",
//             zIndex: 9999,
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "12px",
//               padding: "24px 32px",
//               minWidth: "320px",
//               maxWidth: "90%",
//               boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
//               textAlign: "center",
//               animation: "fadeInDown 0.3s ease-out",
//             }}
//           >
//             <h3 style={{ marginBottom: "20px", fontSize: "18px", color: "#333" }}>
//               🌐 Select Report Language
//             </h3>
//             <div style={{ display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
//               <button
//                 onClick={() => handleLanguageSelection("en")}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#007bff",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                   transition: "background-color 0.2s",
//                 }}
//               >
//                 English
//               </button>
//               <button
//                 onClick={() => handleLanguageSelection("tetum")}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#28a745",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                   transition: "background-color 0.2s",
//                 }}
//               >
//                 Tetum
//               </button>
//             </div>
//             <button
//               onClick={() => setShowLanguageModal(false)}
//               style={{
//                 marginTop: "20px",
//                 padding: "8px 16px",
//                 backgroundColor: "#6c757d",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: "4px",
//                 cursor: "pointer",
//               }}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="hotspot-container" ref={containerRef}>
//         <MapContainer
//           center={center}
//           zoom={INITIAL_VIEW_STATE.zoom}
//           style={{ height: "75vh", width: "100%" }}
//         >
//           <TileLayer
//             url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
//             attribution="Tiles © Esri — Esri, DeLorme, NAVTEQ"
//           />
//           <LayersControl position="topright">
//             {hotspotData && (
//               <LayersControl.Overlay name="Hotspots" checked>
//                 <GeoJSON
//                   data={hotspotData}
//                   style={hotspotStyle}
//                   onEachFeature={onEachHotspotFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {municipalityData && (
//               <LayersControl.Overlay name="Municipalities" checked>
//                 <GeoJSON
//                   data={municipalityData}
//                   style={municipalityStyle}
//                   onEachFeature={onEachMunicipalityFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {submunicipalityData && (
//               <LayersControl.Overlay name="Submunicipalities">
//                 <GeoJSON
//                   data={submunicipalityData}
//                   style={submunicipalityStyle}
//                   onEachFeature={onEachSubmunicipalityFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {sucoData && (
//               <LayersControl.Overlay name="Sucos">
//                 <GeoJSON
//                   data={sucoData}
//                   style={sucoStyle}
//                   onEachFeature={onEachSucoFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//           </LayersControl>
//           <div
//             style={{
//               position: "absolute",
//               bottom: "2px",
//               right: "2px",
//               background: "white",
//               padding: "10px",
//               border: "1px solid #ccc",
//               zIndex: 1000,
//             }}
//           >
//             <LegendItem color="rgba(255, 0, 0, 1)" label="Hotspots" />
//           </div>
//           {info && (
//               <div
//                 style={{
//                   position: "absolute",
//                   bottom: "13px",
//                   left: "35px",
//                   fontSize: "12px",
//                   zIndex: 1000,
//                   backgroundColor: "white",
//                   padding: "5px",
//                   borderRadius: "5px",
//                   boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 72 hour hotspot information  based on latest data is avaiable from NDVI, LST.
//               </div>
//             )}
//             <InfoButton setInfo={setInfo} />
//         </MapContainer>
//       </div>
//     </>
//   );
// };

// const LegendItem = ({ color, label }) => (
//   <div style={{ marginBottom: "5px" }}>
//     <span
//       style={{
//         display: "inline-block",
//         width: "20px",
//         height: "10px",
//         background: color,
//         marginRight: "5px",
//       }}
//     ></span>
//     {label}
//   </div>
// );

// export default Hotspot;



// ************************** pdf with the edit advisory

// import React, { useEffect, useState, useRef } from 'react';
// import { MapContainer, TileLayer, GeoJSON, LayersControl } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import * as turf from '@turf/turf';
// import domtoimage from 'dom-to-image';
// import { jsPDF } from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import { FaSave } from 'react-icons/fa';
// import { FiPlusCircle, FiTrash2 } from 'react-icons/fi';

// // Risk level translations
// const translations = {
//   en: {
//     title: 'DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM',
//     warningTitle: 'Fire Hotspots Advisory for Timor-Leste',
//     advisoryNumber: 'Advisory number: ',
//     issuedBy: 'Issued by: ',
//     issuedAt: 'Date & Time: ',
//     overview: 'Overview',
//     highRiskWarning: 'A forecast has been issued for high fire risk hotspots in several sucos within [highRiskMunicipalities]. Immediate precautions are recommended to prevent fire outbreaks.',
//     mapHeading: 'Fire Hotspot Risk Map',
//     tableHeaders: ['Municipality', 'Sub-Municipality', 'Suco', 'Risk Level'],
//     generalAdvisory: 'General Advisory',
//     advisoryIntro: 'The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and prevent fire outbreaks:',
//     advisoryTableHeaders: ['Type', 'Points'],
//     advisoryPoints: [
//       {
//         type: 'Do\'s',
//         points: [
//           'Secure flammable materials away from heat-prone areas.',
//           'Ensure any outdoor fire or heat-producing activity is fully extinguished before leaving.',
//         ],
//       },
//       {
//         type: 'Don\'ts',
//         points: [
//           'Do not light fires or burn waste near vegetation or dry areas.',
//           'Do not engage in open burning activities during high heat periods.',
//         ],
//       },
//     ],
//     noteLabel: 'Note: ',
//     noteText: 'The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.',
//     footer: 'DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986',
//     page: 'Page [i] of [pageCount]',
//   },
//   tetum: {
//     title: 'SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE',
//     warningTitle: 'Avisu kona ba Rai Manas iha Timor-Leste',
//     advisoryNumber: 'Númeru Aviso: ',
//     issuedBy: 'Ema-husik husi: ',
//     issuedAt: 'Data no Oras: ',
//     overview: 'VISAUN JERAL',
//     highRiskWarning: 'Forescast ida ema-husik ona kona-ba risku foho altus iha suco balun iha [highRiskMunicipalities]. Rekomenda prevensaun imediata atu prevene foho.',
//     mapHeading: 'MAPA RISKU HOTSPOT FOHO',
//     tableHeaders: ['Munisípiu', 'Sub-munisípiu', 'Suco', 'Nivel Risku'],
//     generalAdvisory: 'KONSELLU JERAL',
//     advisoryIntro: 'Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no prevene foho:',
//     advisoryTableHeaders: ['Tipu', 'Konsellu'],
//     advisoryPoints: [
//       {
//         type: 'Diak Halo',
//         points: [
//           'Tau hela materiál sira ne\'ebé bele haksolok fatin hela toos no manas.',
//           'Konfirma katak hela-fatin ne\'ebé manas ka iha api, sei la iha risku fatin molok ita halai.',
//         ],
//       },
//       {
//         type: 'Labele Halo',
//         points: [
//           'Labele sunu ai-ruin ka lixu besik toos ka fatin matak.',
//           'Labele halo sunu iha loron ne\'ebé manas tebes.',
//         ],
//       },
//     ],
//     noteLabel: 'Nota: ',
//     noteText: 'Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.',
//     footer: 'SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986',
//     page: 'Pajina [i] husi [pageCount]',
//   },
// };

// const riskLevelTranslations = {
//   en: { 3: 'High Risk' },
//   tetum: { 3: 'Risku Altus' },
// };

// const loadImage = (src) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = 'Anonymous';
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = src;
//   });
// };

// const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
//   const bannerHeight = 20;
//   const bannerWidth = pageWidth - 2 * sideMargin;
//   if (bannerImage) {
//     pdf.addImage(bannerImage, 'PNG', sideMargin, topMargin, bannerWidth, bannerHeight);
//   }
//   return topMargin + bannerHeight + 5;
// };

// const generatePdfWithImage = async (dataUrl, hotspotTable, municipalityData, language, formData) => {
//   const pdf = new jsPDF('portrait', 'mm', 'a4');
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();
//   const sideMargin = 10;
//   const topMargin = 10;
//   const footerHeight = 10;
//   const marginBottom = 10;
//   const bannerHeight = 20;
//   const headerHeight = topMargin + bannerHeight + 5;
//   const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom;
//   let currentY;

//   const t = translations[language];
//   const riskT = riskLevelTranslations[language];

//   // Load banner image
//   let bannerImage;
//   const bannerPath = language === 'en' ? '/pdf/banner.png' : '/pdf/tetumbanner.png';
//   try {
//     bannerImage = await loadImage(bannerPath);
//   } catch (error) {
//     console.warn(`Failed to load ${bannerPath} }`, error);
//     bannerImage = null;
//   }

//   const addPageWithHeader = () => {
//     pdf.addPage();
//     return addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//   };

//   currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//   currentY += 5;

//   // Warning title
//   pdf.setFont('helvetica', 'bold');
//   pdf.setFontSize(14);
//   pdf.setTextColor(0, 0, 0);
//   if (currentY + 10 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.text(formData.warningTitle || t.warningTitle, pageWidth / 2, currentY, { align: 'center' });
//   currentY += 10;

//   // Date formatting
//   const now = new Date();
//   const formattedDate = new Intl.DateTimeFormat('en-GB', {
//     timeZone: 'Asia/Dili',
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     hour12: true,
//   }).format(now);

//   const [datePart, timePartRaw] = formattedDate.split(', ');
//   const [day, month, year] = datePart.split('/');
//   const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
//   const [_, hour, minute, second, period] = timeMatch;
//   const defaultDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;

//   pdf.setFontSize(10);

//   if (currentY + 6 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }

//   // Advisory number and issued by
//   pdf.setFont('helvetica', 'bold');
//   const advisoryNumberLabel = t.advisoryNumber;
//   pdf.text(advisoryNumberLabel, sideMargin, currentY);
//   pdf.setFont('helvetica', 'normal');
//   pdf.text(formData.advisoryNumber || '1', sideMargin + pdf.getTextWidth(advisoryNumberLabel) + 2, currentY);
//   pdf.setFont('helvetica', 'bold');
//   const issuedByLabel = t.issuedBy;
//   const rightText = `${issuedByLabel} ${formData.issuedBy || 'Department of Meteorology'}`;
//   const rightTextWidth = pdf.getTextWidth(rightText);
//   const rightX = pageWidth - sideMargin - rightTextWidth;
//   pdf.text(issuedByLabel, rightX, currentY);
//   pdf.setFont('helvetica', 'normal');
//   pdf.text(formData.issuedBy || 'Department of Meteorology', rightX + pdf.getTextWidth(issuedByLabel) + 2, currentY);
//   currentY += 6;

//   if (currentY + 6 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.setFont('helvetica', 'bold');
//   pdf.text(t.issuedAt, sideMargin, currentY);
//   pdf.setFont('helvetica', 'normal');
//   pdf.text(formData.issuedAt || defaultDateTime, sideMargin + pdf.getTextWidth(t.issuedAt) + 2, currentY);
//   currentY += 6;

//   currentY += 5;

//   // High-risk municipalities
//   const highRiskMunicipalities = [...new Set(
//     hotspotTable
//       .filter((row) => row.risk >= 3)
//       .map((row) => row.municipality),
//   )].join(', ') || (language === 'en' ? 'No high-risk areas identified' : 'Laiha fatin ho risku altus identifika');

//   currentY += 5;

//   // Overview section
//   if (currentY + 10 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.setFontSize(12);
//   pdf.setFont('helvetica', 'bold');
//   pdf.setFillColor(202, 217, 239);
//   pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//   pdf.setTextColor(0, 0, 0);
//   pdf.text(formData.overview || t.overview, sideMargin + 2, currentY - 2, { align: 'left' });
//   currentY += 10;

//   // Warning message
//   const warningText = [formData.highRiskWarning.replace('[highRiskMunicipalities]', highRiskMunicipalities)];
//   pdf.setFontSize(10);
//   pdf.setFont('helvetica', 'normal');
//   warningText.forEach((line) => {
//     const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
//     lines.forEach((splitLine) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(splitLine, sideMargin, currentY);
//       currentY += 6;
//     });
//     currentY += 2;
//   });
//   currentY += 5;

//   // Map heading
//   if (currentY + 10 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.setFontSize(12);
//   pdf.setFont('helvetica', 'bold');
//   pdf.setFillColor(202, 217, 239);
//   pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//   pdf.setTextColor(0, 0, 0);
//   pdf.text(formData.mapHeading || t.mapHeading, sideMargin + 2, currentY - 2, { align: 'left' });
//   currentY += 5;

//   // Add map image
//   if (dataUrl) {
//     const img = await loadImage(dataUrl);
//     const availableWidth = pageWidth - 2 * sideMargin;
//     const imgHeight = (img.height * availableWidth) / img.width;
//     if (currentY + imgHeight + 5 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.addImage(dataUrl, 'PNG', sideMargin, currentY, availableWidth, imgHeight);
//     currentY += imgHeight + 5;
//   }

//   // Table data
//   const tableData = hotspotTable.map((row) => [
//     row.municipality,
//     row.submunicipality,
//     row.suco,
//     riskT[row.risk] || row.risk,
//   ]);

//   // Add table
//   if (currentY + 20 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   autoTable(pdf, {
//     startY: currentY,
//     head: [t.tableHeaders],
//     body: tableData,
//     theme: 'grid',
//     headStyles: { fillColor: [225, 232, 242], halign: 'left', fontStyle: 'bold', textColor: 'black' },
//     styles: { fontSize: 9, cellPadding: 3 },
//     columnStyles: {
//       0: { cellWidth: 40 },
//       1: { cellWidth: 40 },
//       2: { cellWidth: 40 },
//       3: { cellWidth: 40 },
//     },
//     margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//     willDrawPage: (data) => {
//       data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     },
//     didDrawPage: (data) => {
//       currentY = data.cursor.y + 10;
//     },
//   });

//   currentY += 5;

//   // General Advisory section
//   if (currentY + 10 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.setFontSize(12);
//   pdf.setFont('helvetica', 'bold');
//   pdf.setFillColor(202, 217, 239);
//   pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//   pdf.setTextColor(0, 0, 0);
//   pdf.text(formData.generalAdvisory || t.generalAdvisory, sideMargin + 2, currentY - 2, { align: 'left' });
//   currentY += 7;

//   // Advisory intro
//   pdf.setFontSize(10);
//   pdf.setFont('helvetica', 'normal');
//   if (currentY + 6 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   const introLines = pdf.splitTextToSize(formData.advisoryIntro || t.advisoryIntro, pageWidth - 2 * sideMargin);
//   introLines.forEach((line) => {
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.text(line, sideMargin, currentY);
//     currentY += 6;
//   });

//   currentY += 5;

//   // Advisory table
//   const advisoryTableData = formData.advisoryPoints.map((category) => [
//     category.type,
//     category.points.map((point) => `• ${point}`).join('\n'),
//   ]);

//   if (currentY + 20 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   autoTable(pdf, {
//     startY: currentY,
//     head: [t.advisoryTableHeaders],
//     body: advisoryTableData,
//     theme: 'grid',
//     headStyles: { fillColor: [225, 232, 242], halign: 'left', fontStyle: 'bold', textColor: 'black' },
//     styles: { fontSize: 9, cellPadding: { top: 3, right: 3, bottom: 3, left: 5 }, overflow: 'linebreak', lineHeight: 1.2 },
//     columnStyles: {
//       0: { cellWidth: 40, halign: 'left' },
//       1: { cellWidth: pageWidth - 2 * sideMargin - 40, halign: 'left' },
//     },
//     margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//     willDrawPage: (data) => {
//       data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     },
//     didDrawPage: (data) => {
//       currentY = data.cursor.y + 10;
//     },
//   });

//   currentY += 5;

//   // Note section
//   if (currentY + 12 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.setFontSize(10);
//   pdf.setFont('helvetica', 'bold');
//   pdf.text(t.noteLabel, sideMargin, currentY);
//   currentY += 6;
//   pdf.setFont('helvetica', 'normal');
//   const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
//   noteLines.forEach((line) => {
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.text(line, sideMargin, currentY);
//     currentY += 6;
//   });
//   currentY += 4;

//   currentY += 12;

//   if (currentY + 6 > availablePageHeight + headerHeight) {
//     currentY = addPageWithHeader();
//   }
//   pdf.setFont('helvetica', 'bold');
//   pdf.text('*****', (pageWidth - pdf.getTextWidth('*****')) / 2, currentY);
//   currentY += 6;
//   pdf.setFont('helvetica', 'normal');

//   // Add footer to all pages
//   const pageCount = pdf.internal.getNumberOfPages();
//   const footerYOffset = 5;
//   for (let i = 1; i <= pageCount; i++) {
//     pdf.setPage(i);
//     pdf.setFontSize(8);
//     pdf.text(
//       t.footer,
//       pageWidth / 2,
//       pageHeight - footerHeight + footerYOffset - 2,
//       { align: 'center' },
//     );
//     pdf.text(
//       t.page.replace('[i]', i).replace('[pageCount]', pageCount),
//       pageWidth / 2,
//       pageHeight - footerHeight + footerYOffset + 3,
//       { align: 'center' },
//     );
//   }

//   return pdf.output('blob');
// };

// const Hotspot = () => {
//   const [hotspotData, setHotspotData] = useState(null);
//   const [municipalityData, setMunicipalityData] = useState(null);
//   const [submunicipalityData, setSubmunicipalityData] = useState(null);
//   const [sucoData, setSucoData] = useState(null);
//   const [hotspotTable, setHotspotTable] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showPreview, setShowPreview] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);
//   const [saveMessage, setSaveMessage] = useState({ type: '', text: '' });
//   const [formData, setFormData] = useState({
//     en: { ...translations.en, advisoryPoints: JSON.parse(JSON.stringify(translations.en.advisoryPoints)) },
//     tetum: { ...translations.tetum, advisoryPoints: JSON.parse(JSON.stringify(translations.tetum.advisoryPoints)) },
//     dataUrl: null,
//   });
//   const [editField, setEditField] = useState({ lang: null, field: null, catIndex: null, pointIndex: null, type: null });
//   const [activeTab, setActiveTab] = useState('en');
//   const mapRef = useRef(null);

//   const center = [-8.7742, 125.675];
//   const INITIAL_VIEW_STATE = { zoom: 8.5 };

//   // Fetch data
//   useEffect(() => {
//     fetch('/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson')
//       .then((response) => response.json())
//       .then((data) => setHotspotData(data))
//       .catch((error) => console.error('Error loading hotspot data:', error));
//     fetch('/DATA/OSMbased_adm1_boundary.json')
//       .then((response) => response.json())
//       .then((data) => setMunicipalityData(data))
//       .catch((error) => console.error('Error loading municipality data:', error));
//     fetch('/DATA/OSMbased_adm2_boundary.json')
//       .then((response) => response.json())
//       .then((data) => setSubmunicipalityData(data))
//       .catch((error) => console.error('Error loading submunicipality data:', error));
//     fetch('/DATA/OSMbased_adm3_boundary.json')
//       .then((response) => response.json())
//       .then((data) => setSucoData(data))
//       .catch((error) => console.error('Error loading suco data:', error));
//   }, []);

//   // Process hotspot data
//   useEffect(() => {
//     if (hotspotData && sucoData && submunicipalityData && municipalityData) {
//       const tableData = hotspotData.features.map((hotspot) => {
//         const centroid = turf.centroid(hotspot);
//         let sucoName = 'Unknown';
//         let submunicipalityName = 'Unknown';
//         let municipalityName = 'Unknown';

//         const sucoFeature = sucoData.features.find((suco) =>
//           turf.booleanPointInPolygon(centroid, suco),
//         );
//         if (sucoFeature && sucoFeature.properties) {
//           sucoName = sucoFeature.properties.ADM3 || 'Unknown';
//           const sucoCentroid = turf.centroid(sucoFeature);
//           const submunicipalityFeature = submunicipalityData.features.find((sub) =>
//             turf.booleanPointInPolygon(sucoCentroid, sub),
//           );
//           if (submunicipalityFeature && submunicipalityFeature.properties) {
//             submunicipalityName = submunicipalityFeature.properties.ADM2 || 'Unknown';
//             const subCentroid = turf.centroid(submunicipalityFeature);
//             const municipalityFeature = municipalityData.features.find((mun) =>
//               turf.booleanPointInPolygon(subCentroid, mun),
//             );
//             if (municipalityFeature && municipalityFeature.properties) {
//               municipalityName = municipalityFeature.properties.ADM1 || 'Unknown';
//             }
//           }
//         }
//         return {
//           suco: sucoName,
//           submunicipality: submunicipalityName,
//           municipality: municipalityName,
//           risk: hotspot.properties.risk || 'Unknown',
//         };
//       });
//       setHotspotTable(tableData);
//     }
//   }, [hotspotData, sucoData, submunicipalityData, municipalityData]);

//   // Handlers for form data
//   const handleStringChange = (lang, field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [lang]: { ...prev[lang], [field]: value },
//     }));
//   };

//   const handleAdvisoryPointChange = (lang, categoryIndex, pointIndex, value) => {
//     setFormData((prev) => {
//       const newPoints = [...prev[lang].advisoryPoints[categoryIndex].points];
//       newPoints[pointIndex] = value;
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[categoryIndex] = { ...newAdvisoryPoints[categoryIndex], points: newPoints };
//       return { ...prev, [lang]: { ...prev[lang], advisoryPoints: newAdvisoryPoints } };
//     });
//   };

//   const handleAdvisoryTypeChange = (lang, categoryIndex, value) => {
//     setFormData((prev) => {
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[categoryIndex] = { ...newAdvisoryPoints[categoryIndex], type: value };
//       return { ...prev, [lang]: { ...prev[lang], advisoryPoints: newAdvisoryPoints } };
//     });
//   };

//   const addAdvisoryPoint = (lang, categoryIndex) => {
//     setFormData((prev) => {
//       const newPoints = [...prev[lang].advisoryPoints[categoryIndex].points, 'New advisory point'];
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[categoryIndex] = { ...newAdvisoryPoints[categoryIndex], points: newPoints };
//       return { ...prev, [lang]: { ...prev[lang], advisoryPoints: newAdvisoryPoints } };
//     });
//   };

//   const removeAdvisoryPoint = (lang, categoryIndex, pointIndex) => {
//     setFormData((prev) => {
//       const newPoints = prev[lang].advisoryPoints[categoryIndex].points.filter((_, i) => i !== pointIndex);
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[categoryIndex] = { ...newAdvisoryPoints[categoryIndex], points: newPoints };
//       return { ...prev, [lang]: { ...prev[lang], advisoryPoints: newAdvisoryPoints } };
//     });
//   };

//   const addAdvisoryCategory = (lang) => {
//     setFormData((prev) => {
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints, { type: 'write new Type', points: ['Enter new point'] }];
//       return { ...prev, [lang]: { ...prev[lang], advisoryPoints: newAdvisoryPoints } };
//     });
//   };

//   const removeAdvisoryCategory = (lang, categoryIndex) => {
//     setFormData((prev) => {
//       const newAdvisoryPoints = prev[lang].advisoryPoints.filter((_, i) => i !== categoryIndex);
//       return { ...prev, [lang]: { ...prev[lang], advisoryPoints: newAdvisoryPoints } };
//     });
//   };

//   const handleGeneratePreview = async () => {
//     setLoading(true);
//     try {
//       const dataUrl = await domtoimage.toPng(mapRef.current, {
//         width: mapRef.current.offsetWidth,
//         height: mapRef.current.offsetHeight,
//         style: { background: 'white' },
//         quality: 0.95,
//       });
//       setFormData((prev) => ({ ...prev, dataUrl }));
//       setShowPreview(true);
//     } catch (error) {
//       console.error('Failed to capture map image:', error);
//       setSaveMessage({ type: 'error', text: 'Failed to generate preview. Please try again.' });
//       setTimeout(() => setSaveMessage({ type: '', text: '' }), 5000);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSave = async () => {
//     if (!formData.dataUrl || !hotspotTable.length) {
//       setSaveMessage({ type: 'error', text: 'Cannot generate PDFs: Data is missing.' });
//       setTimeout(() => setSaveMessage({ type: '', text: '' }), 5000);
//       return;
//     }

//     setIsSaving(true);
//     setSaveMessage({ type: '', text: '' });

//     try {
//       const pdfEn = await generatePdfWithImage(formData.dataUrl, hotspotTable, municipalityData, 'en', formData.en);
//       const pdfTetum = await generatePdfWithImage(formData.dataUrl, hotspotTable, municipalityData, 'tetum', formData.tetum);

//       const linkEn = document.createElement('a');
//       linkEn.href = URL.createObjectURL(pdfEn);
//       linkEn.download = 'DRRDSS-Hotspot-Advisory-English.pdf';
//       linkEn.click();
//       URL.revokeObjectURL(linkEn.href);

//       const linkTetum = document.createElement('a');
//       linkTetum.href = URL.createObjectURL(pdfTetum);
//       linkTetum.download = 'DRRDSS-Hotspot-Advisory-Tetum.pdf';
//       linkTetum.click();
//       URL.revokeObjectURL(linkTetum.href);

//       setSaveMessage({ type: 'success', text: 'Advisories saved successfully!' });
//     } catch (error) {
//       console.error('Failed to generate PDFs:', error);
//       setSaveMessage({ type: 'error', text: 'Failed to save advisories. Please try again.' });
//     } finally {
//       setIsSaving(false);
//       setTimeout(() => setSaveMessage({ type: '', text: '' }), 5000);
//     }
//   };

//   // Styles for GeoJSON layers
//   const hotspotStyle = {
//     color: 'red',
//     weight: 2,
//     fillColor: 'red',
//     fillOpacity: 0.9,
//   };

//   const municipalityStyle = {
//     color: 'black',
//     weight: 0.5,
//     fillColor: 'blue',
//     fillOpacity: 0.0,
//   };

//   const submunicipalityStyle = {
//     color: 'green',
//     weight: 2,
//     fillColor: 'green',
//     fillOpacity: 0.0,
//   };

//   const sucoStyle = {
//     color: 'black',
//     weight: 1,
//     fillColor: 'gray',
//     fillOpacity: 0.1,
//   };

//   const onEachHotspotFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `
//         <b>Hotspot</b><br>
//         ID: ${feature.id || 'Unknown'}<br>
//         Risk: ${feature.properties.risk || 'Unknown'}<br>
//         Count: ${feature.properties.count || 'Unknown'}
//       `;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachMunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || 'Unknown'}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSubmunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || 'Unknown'}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSucoFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || 'Unknown'}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const renderPreview = (lang) => {
//     const t = formData[lang];
//     const highRiskMunicipalities = [...new Set(
//       hotspotTable
//         .filter((row) => row.risk >= 3)
//         .map((row) => row.municipality),
//     )].join(', ') || (lang === 'en' ? 'No high-risk areas identified' : 'Laiha fatin ho risku altus identifika');

//     return (
//       <div
//         className="bg-white shadow-lg border border-gray-300 font-helvetica"
//         style={{
//           width: '210mm',
//           minHeight: '297mm',
//           padding: '10mm',
//           fontSize: '10pt',
//           lineHeight: '1.2',
//         }}
//       >
//         {/* Header */}
//         <header style={{ marginBottom: '5mm' }}>
//           <img
//             src={lang === 'en' ? '/pdf/banner.png' : '/pdf/tetumbanner.png'}
//             alt="Banner"
//             style={{ width: '190mm', height: '20mm', marginBottom: '2mm' }}
//           />
//         </header>

//         {/* Editable Sections */}
//         <section>
//           {/* Warning Title */}
//           {editField.lang === lang && editField.field === 'warningTitle' ? (
//             <input
//               type="text"
//               value={t.warningTitle}
//               onChange={(e) => handleStringChange(lang, 'warningTitle', e.target.value)}
//               onBlur={() => setEditField({ lang: null, field: null })}
//               className=" text-center font-bold border border-blue-500 p-1 mb-4"
//               style={{ fontSize: '14pt', width:'100%' }}
//               autoFocus
//             />
//           ) : (
//             <div
//               className=" text-center font-bold mb-4 cursor-pointer"
//               style={{ fontSize: '14pt', width:'100%' }}
//               onClick={() => setEditField({ lang, field: 'warningTitle' })}
//             >
//               {t.warningTitle}
//             </div>
//           )}

//           {/* Advisory Number and Issued By */}
//           <div className="flex justify-between mb-4">
//             <div>
//               {editField.lang === lang && editField.field === 'advisoryNumber' ? (
//                 <input
//                   type="text"
//                   value={t.advisoryNumber}
//                   onChange={(e) => handleStringChange(lang, 'advisoryNumber', e.target.value)}
//                   onBlur={() => setEditField({ lang: null, field: null })}
//                   className="border border-blue-500 p-1 w-70"
//                   style={{ fontSize: '10pt' ,width:'100%'}}
//                   autoFocus
//                 />
//               ) : (
//                 <span
//                   className="cursor-pointer"
//                   onClick={() => setEditField({ lang, field: 'advisoryNumber' })}
//                   style={{ fontSize: '10pt' }}
//                 >
//                   <span className="font-bold">{translations[lang].advisoryNumber}</span> {t.advisoryNumber}
//                 </span>
//               )}
//             </div>
//             <div>
//               {editField.lang === lang && editField.field === 'issuedBy' ? (
//                 <input
//                   type="text"
//                   value={t.issuedBy}
//                   onChange={(e) => handleStringChange(lang, 'issuedBy', e.target.value)}
//                   onBlur={() => setEditField({ lang: null, field: null })}
//                   className="border border-blue-500 p-1 w-40"
//                   style={{ fontSize: '10pt',width:'100%' }}
//                   autoFocus
//                 />
//               ) : (
//                 <span
//                   className="cursor-pointer"
//                   onClick={() => setEditField({ lang, field: 'issuedBy' })}
//                   style={{ fontSize: '10pt' }}
//                 >
//                   <span className="font-bold">{translations[lang].issuedBy}</span> {t.issuedBy}
//                 </span>
//               )}
//             </div>
//           </div>

//           {/* Issued At */}
//           <div className="mb-4">
//             {editField.lang === lang && editField.field === 'issuedAt' ? (
//               <input
//                 type="text"
//                 value={t.issuedAt}
//                 onChange={(e) => handleStringChange(lang, 'issuedAt', e.target.value)}
//                 onBlur={() => setEditField({ lang: null, field: null })}
//                 className="border border-blue-500 p-1 w-60"
//                 style={{ fontSize: '10pt',width:'100%' }}
//                 autoFocus
//               />
//             ) : (
//               <span
//                 className="cursor-pointer"
//                 onClick={() => setEditField({ lang, field: 'issuedAt' })}
//                 style={{ fontSize: '10pt' }}
//               >
//                 <span className="font-bold">{translations[lang].issuedAt}</span> {t.issuedAt}
//               </span>
//             )}
//           </div>

//           {/* Overview */}
//           <div className="mb-4">
//             {editField.lang === lang && editField.field === 'overview' ? (
//               <input
//                 type="text"
//                 value={t.overview}
//                 onChange={(e) => handleStringChange(lang, 'overview', e.target.value)}
//                 onBlur={() => setEditField({ lang: null, field: null })}
//                 className="w-full font-bold bg-blue-200 p-2 mb-2 border border-blue-500"
//                 style={{ fontSize: '12pt',width:'100%' }}
//                 autoFocus
//               />
//             ) : (
//               <div
//                 className="w-full font-bold bg-blue-200 p-2 mb-2 cursor-pointer"
//                 style={{ fontSize: '12pt' }}
//                 onClick={() => setEditField({ lang, field: 'overview' })}
//               >
//                 {t.overview}
//               </div>
//             )}
//             {editField.lang === lang && editField.field === 'highRiskWarning' ? (
//               <textarea
//                 value={t.highRiskWarning.replace('[highRiskMunicipalities]', highRiskMunicipalities)}
//                 onChange={(e) => handleStringChange(lang, 'highRiskWarning', e.target.value)}
//                 onBlur={() => setEditField({ lang: null, field: null })}
//                 className="w-full border border-blue-500 p-2 h-20"
//                 style={{ fontSize: '10pt',width:'100%' }}
//                 autoFocus
//               />
//             ) : (
//               <div
//                 className="w-full cursor-pointer"
//                 style={{ fontSize: '10pt' }}
//                 onClick={() => setEditField({ lang, field: 'highRiskWarning' })}
//               >
//                 {t.highRiskWarning.replace('[highRiskMunicipalities]', highRiskMunicipalities)}
//               </div>
//             )}
//           </div>

//           {/* Map Heading */}
//           <div className="mb-4">
//             {editField.lang === lang && editField.field === 'mapHeading' ? (
//               <input
//                 type="text"
//                 value={t.mapHeading}
//                 onChange={(e) => handleStringChange(lang, 'mapHeading', e.target.value)}
//                 onBlur={() => setEditField({ lang: null, field: null })}
//                 className="w-full font-bold bg-blue-200 p-2 mb-2 border border-blue-500"
//                 style={{ fontSize: '12pt',width:'100%' }}
//                 autoFocus
//               />
//             ) : (
//               <div
//                 className="w-full font-bold bg-blue-200 p-2 mb-2 cursor-pointer"
//                 style={{ fontSize: '12pt' }}
//                 onClick={() => setEditField({ lang, field: 'mapHeading' })}
//               >
//                 {t.mapHeading}
//               </div>
//             )}
//             {formData.dataUrl && (
//               <img
//                 src={formData.dataUrl}
//                 alt="Map"
//                 className="w-full h-auto border border-gray-300 mb-2"
//                 style={{ width: '190mm' }}
//               />
//             )}
//           </div>

//           {/* Table (Non-Editable) */}
//           <div className="mb-4">
//             <div className="overflow-x-auto">
//               <table
//                 className="w-full border-collapse border border-gray-300"
//                 style={{ fontSize: '9pt' }}
//               >
//                 <thead>
//                   <tr className="bg-blue-100">
//                     {translations[lang].tableHeaders.map((header, index) => (
//                       <th
//                         key={index}
//                         className="border border-gray-300 p-2 text-left font-bold"
//                         style={{ width: '40mm' }}
//                       >
//                         {header}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {hotspotTable.map((row, index) => (
//                     <tr key={index} className="border border-gray-300">
//                       <td className="border border-gray-300 p-2">{row.municipality}</td>
//                       <td className="border border-gray-300 p-2">{row.submunicipality}</td>
//                       <td className="border border-gray-300 p-2">{row.suco}</td>
//                       <td className="border border-gray-300 p-2">
//                         {riskLevelTranslations[lang][row.risk] || row.risk}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* General Advisory */}
//           <div className="mb-4">
//             {editField.lang === lang && editField.field === 'generalAdvisory' ? (
//               <input
//                 type="text"
//                 value={t.generalAdvisory}
//                 onChange={(e) => handleStringChange(lang, 'generalAdvisory', e.target.value)}
//                 onBlur={() => setEditField({ lang: null, field: null })}
//                 className="w-full font-bold bg-blue-200 p-2 mb-2 border border-blue-500"
//                 style={{ fontSize: '12pt' ,width:'100%'}}
//                 autoFocus
//               />
//             ) : (
//               <div
//                 className="w-full font-bold bg-blue-200 p-2 mb-2 cursor-pointer"
//                 style={{ fontSize: '12pt' }}
//                 onClick={() => setEditField({ lang, field: 'generalAdvisory' })}
//               >
//                 {t.generalAdvisory}
//               </div>
//             )}
//             {editField.lang === lang && editField.field === 'advisoryIntro' ? (
//               <textarea
//                 value={t.advisoryIntro}
//                 onChange={(e) => handleStringChange(lang, 'advisoryIntro', e.target.value)}
//                 onBlur={() => setEditField({ lang: null, field: null })}
//                 className="w-full border border-blue-500 p-2 h-20 mb-2"
//                 style={{ fontSize: '10pt',width:'100%' }}
//                 autoFocus
//               />
//             ) : (
//               <div
//                 className="w-full cursor-pointer mb-2"
//                 style={{ fontSize: '10pt' }}
//                 onClick={() => setEditField({ lang, field: 'advisoryIntro' })}
//               >
//                 {t.advisoryIntro}
//               </div>
//             )}

//             {/* Advisory Points */}
//             <div
//               className="w-full border border-gray-300"
//               style={{ fontSize: '9pt' }}
//             >
//               <table className="w-full border-collapse">
//                 <thead>
//                   <tr className="bg-blue-100">
//                     {translations[lang].advisoryTableHeaders.map((header, index) => (
//                       <th
//                         key={index}
//                         className="border border-gray-300 p-2 text-left font-bold"
//                         style={{ width: index === 0 ? '40mm' : '150mm' }}
//                       >
//                         {header}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {t.advisoryPoints.map((category, catIndex) => (
//                     <tr key={catIndex} className="border border-gray-300 relative">
//                       <td className="border border-gray-300 p-2 align-top">
//                         {editField.lang === lang && editField.field === 'advisoryPoints' && editField.catIndex === catIndex && editField.type === 'type' ? (
//                           <input
//                             type="text"
//                             value={category.type}
//                             onChange={(e) => handleAdvisoryTypeChange(lang, catIndex, e.target.value)}
//                             onBlur={() => setEditField({ lang: null, field: null })}
//                             className="w-full font-bold border border-blue-500 p-1"
//                             style={{ fontSize: '9pt', width:'100%' }}
//                             autoFocus
//                           />
//                         ) : (
//                           <div
//                             className="w-full font-bold cursor-pointer"
//                             onClick={() => setEditField({ lang, field: 'advisoryPoints', catIndex, type: 'type' })}
//                           >
//                             {category.type}
//                           </div>
//                         )}
//                         <button
//                           onClick={() => removeAdvisoryCategory(lang, catIndex)}
//                           className="absolute top-2 right-2 text-red-500 hover:text-red-700"
//                           title="Remove category"
//                         >
//                           <FiTrash2 size={14} />
//                         </button>
//                       </td>
//                       <td className="border border-gray-300 p-2 align-top">
//                         {category.points.map((point, pointIndex) => (
//                           <div key={pointIndex} className="flex items-start gap-2 mb-1">
//                             <span className="mt-1">•</span>
//                             {editField.lang === lang && editField.field === 'points' && editField.catIndex === catIndex && editField.pointIndex === pointIndex ? (
//                               <textarea
//                                 value={point}
//                                 onChange={(e) => handleAdvisoryPointChange(lang, catIndex, pointIndex, e.target.value)}
//                                 onBlur={() => setEditField({ lang: null, field: null })}
//                                 className="flex-1 border border-blue-500 p-2 h-16"
//                                 style={{ fontSize: '9pt',width:'100%' }}
//                                 autoFocus
//                               />
//                             ) : (
//                               <div
//                                 className="flex-1 cursor-pointer"
//                                 onClick={() => setEditField({ lang, field: 'points', catIndex, pointIndex })}
//                               >
//                                 {point}
//                               </div>
//                             )}
//                             <button
//                               onClick={() => removeAdvisoryPoint(lang, catIndex, pointIndex)}
//                               className="text-red-500 hover:text-red-700 p-1"
//                               title="Remove point"
//                             >
//                               <FiTrash2 size={14} />
//                             </button>
//                           </div>
//                         ))}
//                         <button
//                           onClick={() => addAdvisoryPoint(lang, catIndex)}
//                           className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-xs p-2 border border-blue-500 rounded-md"
//                           style={{ fontSize: '9pt' }}
//                         >
//                           <FiPlusCircle size={14} /> Add Point
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <button
//               onClick={() => addAdvisoryCategory(lang)}
//               className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-xs p-2 border border-blue-500 rounded-md mt-2"
//               style={{ fontSize: '9pt' }}
//             >
//               <FiPlusCircle size={14} /> Add Category
//             </button>
//           </div>

//           {/* Note Section (Non-Editable) */}
//           <div className="border-t pt-2 mb-4" style={{ fontSize: '10pt' }}>
//             <span className="font-bold">{translations[lang].noteLabel}</span>
//             <p className="mt-1">{translations[lang].noteText}</p>
//           </div>

//           <div className="text-center font-bold" style={{ fontSize: '10pt' }}>
//             *****
//           </div>
//         </section>

//         {/* Footer (Non-Editable) */}
//         <footer
//           className="border-t pt-2 text-center"
//           style={{ fontSize: '8pt', position: 'absolute', bottom: '10mm', width: '190mm' }}
//         >
//           <p>{translations[lang].footer}</p>
//           <p>{translations[lang].page.replace('[i]', '1').replace('[pageCount]', '1')}</p>
//         </footer>
//       </div>
//     );
//   };

//   return (
//     <div className="p-6 font-helvetica">
//       <div className="flex justify-between items-center mb-4">
//         <h1 className="text-2xl font-semibold">Fire Hotspot Advisory Editor</h1>
//         <div className="flex gap-2">
//           <button
//             onClick={handleGeneratePreview}
//             disabled={loading}
//             className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:bg-blue-400"
//           >
//             {loading ? 'Generating...' : 'Generate Preview'}
//           </button>
//         </div>
//       </div>

//       {saveMessage.text && (
//         <div
//           className={`p-3 mb-4 rounded-md text-sm font-medium ${
//             saveMessage.type === 'error'
//               ? 'bg-red-100 text-red-800 border border-red-200'
//               : 'bg-green-100 text-green-800 border border-green-200'
//           }`}
//         >
//           {saveMessage.text}
//         </div>
//       )}

//       {showPreview ? (
//         <div>
//           {/* Tabs */}
//           <div className="flex mb-4 border-b border-gray-300">
//             <button
//               onClick={() => setActiveTab('en')}
//               className={`px-4 py-2 font-semibold ${
//                 activeTab === 'en'
//                   ? 'border-b-2 border-blue-600 text-blue-600'
//                   : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               English
//             </button>
//             <button
//               onClick={() => setActiveTab('tetum')}
//               className={`px-4 py-2 font-semibold ${
//                 activeTab === 'tetum'
//                   ? 'border-b-2 border-blue-600 text-blue-600'
//                   : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Tetum
//             </button>
//           </div>

//           {/* Preview */}
//           <div className="flex justify-center">
//             {activeTab === 'en' && renderPreview('en')}
//             {activeTab === 'tetum' && renderPreview('tetum')}
//           </div>

//           {/* Save Changes Button */}
//           <div className="flex justify-center mt-4">
//             <button
//               onClick={handleSave}
//               disabled={isSaving}
//               className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 disabled:bg-gray-400 flex items-center gap-2"
//             >
//               <FaSave size={16} />
//               {isSaving ? 'Saving...' : 'Save Changes'}
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div className="hotspot-container" ref={mapRef}>
//           <MapContainer
//             center={center}
//             zoom={INITIAL_VIEW_STATE.zoom}
//             style={{ height: '75vh', width: '100%' }}
//           >
//             <TileLayer
//               url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
//               attribution="Tiles © Esri — Esri, DeLorme, NAVTEQ"
//             />
//             <LayersControl position="topright">
//               {hotspotData && (
//                 <LayersControl.Overlay name="Hotspots" checked>
//                   <GeoJSON
//                     data={hotspotData}
//                     style={hotspotStyle}
//                     onEachFeature={onEachHotspotFeature}
//                   />
//                 </LayersControl.Overlay>
//               )}
//               {municipalityData && (
//                 <LayersControl.Overlay name="Municipalities" checked>
//                   <GeoJSON
//                     data={municipalityData}
//                     style={municipalityStyle}
//                     onEachFeature={onEachMunicipalityFeature}
//                   />
//                 </LayersControl.Overlay>
//               )}
//               {submunicipalityData && (
//                 <LayersControl.Overlay name="Submunicipalities">
//                   <GeoJSON
//                     data={submunicipalityData}
//                     style={submunicipalityStyle}
//                     onEachFeature={onEachSubmunicipalityFeature}
//                   />
//                 </LayersControl.Overlay>
//               )}
//               {sucoData && (
//                 <LayersControl.Overlay name="Sucos">
//                   <GeoJSON
//                     data={sucoData}
//                     style={sucoStyle}
//                     onEachFeature={onEachSucoFeature}
//                   />
//                 </LayersControl.Overlay>
//               )}
//             </LayersControl>
//           </MapContainer>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Hotspot;



// import React, { useEffect, useState, useRef } from "react";
// import { MapContainer, TileLayer, GeoJSON, LayersControl, useMap } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import * as turf from "@turf/turf";
// import domtoimage from "dom-to-image";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import { FaCircleInfo } from "react-icons/fa6";
// import { PDFDocument } from "@react-pdf/renderer";
// import { saveAs } from "file-saver";

// // Risk level translations
// const translations = {
//   en: {
//     title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
//     warningTitle: "Fire Hotspots Advisory for Timor-Leste",
//     advisoryNumber: "Advisory number: ",
//     issuedBy: "Issued by:",
//     issuedAt: "Date & Time:",
//     overview: "Overview",
//     highRiskWarning: "A forecast has been issued for high fire risk hotspots in several sucos within [highRiskMunicipalities]. Immediate precautions are recommended to prevent fire outbreaks.",
//     mapHeading: "Fire Hotspot Risk Map",
//     tableHeaders: ["Municipality", "Sub-Municipality", "Suco", "Risk Level"],
//     generalAdvisory: "General Advisory",
//     advisoryIntro: "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and prevent fire outbreaks:",
//     advisoryTableHeaders: ["Type", "Advisory"],
//     advisoryPoints: [
//       {
//         type: "Do's",
//         points: [
//           "Secure flammable materials away from heat-prone areas.",
//           "Ensure any outdoor fire or heat-producing activity is fully extinguished before leaving."
//         ]
//       },
//       {
//         type: "Don'ts",
//         points: [
//           "Do not light fires or burn waste near vegetation or dry areas.",
//           "Do not engage in open burning activities during high heat periods.",
//           "Avoid entering high-risk areas without proper protective gear or local clearance."
//         ]
//       },
//       {
//         type: "Prevention and Preparedness",
//         points: [
//           "Keep emergency contact numbers of fire services and local authorities easily accessible.",
//           "Report any visible smoke, fire, or abnormal heat activity immediately.",
//           "Avoid outdoor activities that may trigger sparks or fires, such as welding or fireworks near dry vegetation.",
//           "Use lanterns, stoves, and heaters with caution in high-risk zones. Ensure equipment is cool before refueling.",
//           "Dispose of smoking materials like cigarettes safely and away from dry areas.",
//           "Do not burn agricultural, industrial, or municipal waste near hotspot regions.",
//           "Prepare and maintain defensible space around homes in at-risk zones by clearing dry debris and combustibles.",
//           "Ensure availability of emergency kits and pre-plan evacuation routes.",
//           "Conduct preparedness drills regularly and identify safe zones in your community."
//         ]
//       },
//       {
//         type: "Evacuation in Case of Extreme Heat or Fire Hotspot Escalation",
//         points: [
//           "Evacuate immediately upon advisories from local authorities or emergency services.",
//           "Protect yourself from heat exposure and possible airborne particles.",
//           "Secure your animals and assist vulnerable individuals during evacuation."
//         ]
//       },
//       {
//         type: "Before Leaving Your House",
//         points: [
//           "Remove all combustible items like gas cylinders, firewood, and dry waste from your surroundings.",
//           "Seal windows, vents, and doors to minimize smoke or heat intrusion.",
//           "Store water in large containers to use in case of emergency cooling.",
//           "Trim dry plants and clean debris around your property to reduce ignition risk.",
//           "Inspect and clean rooftops, gutters, and drainage areas regularly.",
//           "Dampen roofs and exterior walls if advised by emergency services during high-risk alerts."
//         ]
//       },
//       {
//         type: "If Exposed to a Hotspot While Outdoors",
//         points: [
//           "Avoid attempting to outrun fire or heat. Seek refuge in a cleared, low-vegetation area.",
//           "Cover your nose and mouth with a wet cloth to reduce smoke inhalation risk.",
//           "Use water, soil, or nonflammable materials to shield yourself if surrounded by heat or fire."
//         ]
//       },
//       {
//         type: "If Sheltering at Home During a Heat Alert or Hotspot Activation",
//         points: [
//           "Stay calm and indoors. Seal your home to prevent heat and smoke entry.",
//           "Avoid opening hot doors — it may indicate fire or intense heat on the other side.",
//           "Monitor official updates for when it's safe to evacuate or step out."
//         ]
//       },
//       {
//         type: "If Caught in a Vehicle in a Hotspot-Affected Area",
//         points: [
//           "Stay inside the vehicle — it offers better protection than open space.",
//           "Keep windows and air vents closed to avoid smoke and heat exposure.",
//           "Drive cautiously with headlights on and remain alert to surroundings.",
//           "If stopping, park away from vegetation and turn off the engine.",
//           "Stay low inside the vehicle and cover yourself with nonflammable material."
//         ]
//       }
//     ],
//     noteLabel: "Note:",
//     noteText: "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
//     footer: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
//     page: "Page [i] of [pageCount]",
//   },
//   tetum: {
//     title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
//     warningTitle: "Avisu kona ba Rai Manas iha Timor-Leste",
//     advisoryNumber: "Númeru Aviso:",
//     issuedBy: "Ema-husik husi:",
//     issuedAt: "Data no Oras:",
//     overview: "VISAUN JERAL",
//     highRiskWarning: "Forescast ida ema-husik ona kona-ba risku foho altus iha suco balun iha [highRiskMunicipalities]. Rekomenda prevensaun imediata atu prevene foho.",
//     mapHeading: "MAPA RISKU HOTSPOT FOHO",
//     tableHeaders: ["Munisípiu", "Sub-munisípiu", "Suco", "Nivel Risku"],
//     generalAdvisory: "KONSELLU JERAL",
//     advisoryIntro: "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no prevene foho:",
//     advisoryTableHeaders: ["Tipu", "Konsellu"],
//     advisoryPoints: [
//       {
//         type: "Diak Halo",
//         points: [
//           "Tau hela materiál sira ne'ebé bele haksolok fatin hela toos no manas.",
//           "Konfirma katak hela-fatin ne'ebé manas ka iha api, sei la iha risku fatin molok ita halai."
//         ]
//       },
//       {
//         type: "Labele Halo",
//         points: [
//           "Labele sunu ai-ruin ka lixu besik toos ka fatin matak.",
//           "Labele halo sunu iha loron ne'ebé manas tebes.",
//           "Labele tama iha fatin risku boot tan manas boot la'ós ho proteksaun loos ka klaru husi autoridade lokal."
//         ]
//       },
//       {
//         type: "Prevensaun no Preparasaun",
//         points: [
//           "Tau hela numeru kontaktu emergencia hosi servisu bombeiru no autoridade lokal.",
//           "Hatete lalais ba autoridade se haree sukun, api, ka manas boot ne'ebé la normal.",
//           "Labele halo atividade iha liur ne'ebé bele halo iskra ka api, hanesan soldadura ka fogu d'artifísiu besik ai matak.",
//           "Uza lanterna, fogão, no aparato manas ho atensaun iha fatin manas. Labele tau gasolina antes ne'ebé aparatu cool.",
//           "Hamoos sigaru, fósforu, no materiál fumar iha fatin ne'ebé seguru, labele hikas iha fatin matak.",
//           "Labele sunu restu agrikultura, indústria ka lixu municipal besik hotspot.",
//           "Hamoos ai-ruin matak no materiál haksolok iha zona risku, prepara área seguransa iha entorno uma.",
//           "Prepara hela kit emergencia no buat sira ne'ebé importante ba evacuasaun.",
//           "Halo simulasaun evacuasaun no hatene fatin seguransa iha komunidade."
//         ]
//       },
//       {
//         type: "Evakuasaun iha tempu manas ka eskalasaun hotspot",
//         points: [
//           "Sai hela fatin tan dehan hosi autoridade lokal ka servisu emergencia.",
//           "Proteje-an hosi manas tebes no partículas iha ar.",
//           "Toman konta animal sira no ajuda ema matak ka ema ne'ebé iha nesesidade espesiál."
//         ]
//       },
//       {
//         type: "Molok Sai husi Uma",
//         points: [
//           "Taka no hasai buat hotu ne'ebé haksolok hanesan botija gas, ai-ruin, no lixu matak iha entorno uma.",
//           "Taka janela, ventilasaun no odamatan atu prevene fumaça ka manas tama.",
//           "Tau bee iha vasilha boot atu uza ba manan manas ka fumaça.",
//           "Kose ai-ruin matak no halo limpu zona iha nia sorin uma.",
//           "Hamoos telhado, kalha no fatin saluran bee.",
//           "Tau bee iha telhado, paredes no ai sira iha sorin uma karik iha alerta hosi autoridade."
//         ]
//       },
//       {
//         type: "Se Ita iha Liur iha Fatin Hotspot",
//         points: [
//           "Labele halai atu la'o husi api. Bolu hela iha fatin ne'ebé matak no buka área klaru.",
//           "Kobre-an ho kanuru molik atu prevene fumaça tama iha matan no anin.",
//           "Uza bee, rai, ka materiál ne'ebé la bele sunu atu proteje-an se iha risku boot iha fatin."
//         ]
//       },
//       {
//         type: "Se Ita iha Uma Durante Alerta Hotspot",
//         points: [
//           "Tuir diak, hela iha uma. Taka buat hotu atu prevene fumaça ka manas tama.",
//           "Se odamatan manas tebes, labele taka tan bele iha api iha fatin seluk.",
//           "Tuir informasaun ofisiál ba tempu ne'ebé seguru atu sai ka evacuate."
//         ]
//       },
//       {
//         type: "Se Ita iha Karreta iha Fatin Hotspot",
//         points: [
//           "Hela iha laran karreta — liu seguru liu dukur iha liur.",
//           "Taka janela no ventilasaun atu prevene fumaça ka manas tama.",
//           "La'o ho kuidadu no laran moris iha luz karreta.",
//           "Se presiza para: para iha fatin ne'ebé laduun iha vegetasaun, taka motor.",
//           "Hela iha laran karreta no tuun ba rai.",
//           "Kobre-an ho ropa ka materiál ne'ebé la bele sunu."
//         ]
//       }
//     ],
//     noteLabel: "Nota:",
//     noteText: "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
//     footer: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
//     page: "Pajina [i] husi [pageCount]",
//   },
// };

// // Risk level translations
// const riskLevelTranslations = {
//   en: { 3: "High Risk" },
//   tetum: { 3: "Risku Altus" },
// };

// // Helper function to load images
// const loadImage = (src) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = "Anonymous";
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = src;
//   });
// };

// // Helper function to add banner to a page
// const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
//   const bannerHeight = 20; // Height in mm
//   const bannerWidth = pageWidth - 2 * sideMargin; // Span page width minus margins
//   if (bannerImage) {
//     pdf.addImage(
//       bannerImage,
//       "PNG",
//       sideMargin,
//       topMargin,
//       bannerWidth,
//       bannerHeight
//     );
//   }
//   return topMargin + bannerHeight + 5; // Return new currentY (5mm gap)
// };

// // Function to generate PDF and return as Blob
// const generatePdfWithImage = async (dataUrl, hotspotTable, municipalityData, language = "en") => {
//   try {
//     const pdf = new jsPDF("portrait", "mm", "a4");
//     const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm
//     const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
//     const sideMargin = 10;
//     const topMargin = 10;
//     const footerHeight = 10;
//     const marginBottom = 10;
//     const bannerHeight = 20; // Assumed banner height
//     const headerHeight = topMargin + bannerHeight + 5; // 35 mm (10 + 20 + 5)
//     const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom; // ~242 mm
//     let currentY;

//     const t = translations[language];
//     const riskT = riskLevelTranslations[language];

//     // Load banner image based on language
//     let bannerImage;
//     const bannerPath = language === "en" ? "/pdf/banner.png" : "/pdf/tetumbanner.png";
//     try {
//       bannerImage = await loadImage(bannerPath);
//     } catch (error) {
//       console.warn(`Failed to load ${bannerPath}:`, error);
//       bannerImage = null;
//     }

//     // Helper function to add page with header
//     const addPageWithHeader = () => {
//       pdf.addPage();
//       return addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     };

//     // Add banner to first page
//     currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     currentY += 5;

//     // Add warning title
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 0, 0);
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.text(t.warningTitle, pageWidth / 2, currentY, { align: "center" });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 10;

//     // Format date in Asia/Dili timezone
//     const now = new Date();
//     const formattedDate = new Intl.DateTimeFormat("en-GB", {
//       timeZone: "Asia/Dili",
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     }).format(now);

//     const [datePart, timePartRaw] = formattedDate.split(", ");
//     const [day, month, year] = datePart.split("/");
//     const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
//     const [_, hour, minute, second, period] = timeMatch;
//     const formattedTimorDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;

//     pdf.setFontSize(10);

//     // Ensure enough space, else add page
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }

//     // Prepare left and right text with bold labels
//     pdf.setFont("helvetica", "bold");
//     const advisoryNumberLabel = t.advisoryNumber;
//     pdf.text(advisoryNumberLabel, sideMargin, currentY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(" 1", sideMargin + pdf.getTextWidth(advisoryNumberLabel) + 2, currentY);
//     pdf.setFont("helvetica", "bold");
//     const issuedAtLabel = t.issuedAt;
//     const rightText = `${issuedAtLabel} ${formattedTimorDate}`;
//     const rightTextWidth = pdf.getTextWidth(rightText);
//     const rightX = pageWidth - sideMargin - rightTextWidth;
//     pdf.text(issuedAtLabel, rightX, currentY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(formattedTimorDate, rightX + pdf.getTextWidth(issuedAtLabel) + 2, currentY);
//     currentY += 6;

//     // Issued by
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont("helvetica", "bold");
//     const issuedByLabel = t.issuedBy;
//     pdf.text(issuedByLabel, sideMargin, currentY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Department of Meteorology", sideMargin + pdf.getTextWidth(issuedByLabel) + 2, currentY);
//     currentY += 6;

//     currentY += 5;

//     // Identify high-risk municipalities
//     const highRiskMunicipalities = [...new Set(
//       hotspotTable
//         .filter((row) => row.risk >= 3)
//         .map((row) => row.municipality)
//     )].join(", ") || (language === "en" ? "No high-risk areas identified" : "Laiha fatin ho risku altus identifika");

//     currentY += 5;

//     // OVERVIEW section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239); // Background color (light blue)
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
//     pdf.setTextColor(0, 0, 0); // Black text
//     pdf.text(t.overview, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
//     pdf.setTextColor(0, 0, 0); // Reset text color
//     currentY += 10;

//     // Warning message
//     const warningText = [t.highRiskWarning.replace("[highRiskMunicipalities]", highRiskMunicipalities)];
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "normal");
//     warningText.forEach((line) => {
//       const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
//       lines.forEach((splitLine) => {
//         if (currentY + 6 > availablePageHeight + headerHeight) {
//           currentY = addPageWithHeader();
//         }
//         pdf.text(splitLine, sideMargin, currentY);
//         currentY += 6;
//       });
//       currentY += 2;
//     });
//     currentY += 5;

//     currentY += 2;

//     // MAP heading
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239); // Background color (light blue)
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
//     pdf.setTextColor(0, 0, 0); // Black text
//     pdf.text(t.mapHeading, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
//     pdf.setTextColor(0, 0, 0); // Reset text color
//     currentY += 5;

//     // Add map image
//     if (dataUrl) {
//       const img = await loadImage(dataUrl);
//       const availableWidth = pageWidth - 2 * sideMargin;
//       const imgHeight = (img.height * availableWidth) / img.width;

//       if (currentY + imgHeight + 5 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }

//       pdf.addImage(dataUrl, "PNG", sideMargin, currentY, availableWidth, imgHeight);
//       currentY += imgHeight + 5;
//     } else {
//       console.warn("No map image provided for PDF");
//     }
//     currentY += 5;

//     // Prepare table data
//     const tableData = hotspotTable.map((row) => [
//       row.municipality,
//       row.submunicipality,
//       row.suco,
//       riskT[row.risk] || row.risk,
//     ]);

//     // Add table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.tableHeaders],
//       body: tableData,
//       theme: "grid",
//       headStyles: { fillColor: [225, 232, 242], halign: "left", fontStyle: "bold", textColor: "black" },
//       styles: { fontSize: 9, cellPadding: 3 },
//       columnStyles: {
//         0: { cellWidth: 40 },
//         1: { cellWidth: 40 },
//         2: { cellWidth: 40 },
//         3: { cellWidth: 40 },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });

//     currentY += 5;

//     // GENERAL ADVISORY section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239);
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F");
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(t.generalAdvisory, sideMargin + 2, currentY - 1, { align: "left" });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 7;

//     currentY += 5;

//     // Add advisory intro
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "normal");
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     const introLines = pdf.splitTextToSize(t.advisoryIntro, pageWidth - 2 * sideMargin);
//     introLines.forEach((line) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });

//     currentY += 5;

//     // Prepare table data for advisory with bullet points
//     const advisoryTableData = t.advisoryPoints.map((category) => [
//       category.type,
//       category.points.map((point) => `• ${point}`).join("\n")
//     ]);

//     // Add advisory table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.advisoryTableHeaders],
//       body: advisoryTableData,
//       theme: "grid",
//       headStyles: {
//         fillColor: [225, 232, 242],
//         halign: "left",
//         fontStyle: "bold",
//         textColor: "black",
//       },
//       styles: {
//         fontSize: 9,
//         cellPadding: { top: 3, right: 3, bottom: 3, left: 5 },
//         overflow: "linebreak",
//         lineHeight: 1.2,
//       },
//       columnStyles: {
//         0: { cellWidth: 40, halign: "left" },
//         1: { cellWidth: pageWidth - 2 * sideMargin - 40, halign: "left" },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });

//     currentY += 5;

//     // Add Note section
//     if (currentY + 12 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(t.noteLabel, sideMargin, currentY);
//     currentY += 6;
//     pdf.setFont("helvetica", "normal");
//     const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
//     noteLines.forEach((line) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });
//     currentY += 4;

//     currentY += 12;

//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont("helvetica", "bold");
//     pdf.text("*****", (pageWidth - pdf.getTextWidth("*****")) / 2, currentY);
//     currentY += 6;
//     pdf.setFont("helvetica", "normal");

//     // Add footer to all pages
//     const pageCount = pdf.internal.getNumberOfPages();
//     const footerYOffset = 5;
//     for (let i = 1; i <= pageCount; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(8);
//       pdf.text(
//         t.footer,
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset - 2,
//         { align: "center" }
//       );
//       pdf.text(
//         t.page.replace("[i]", i).replace("[pageCount]", pageCount),
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset + 3,
//         { align: "center" }
//       );
//     }

//     // Return PDF as Blob
//     return pdf.output("blob");
//   } catch (error) {
//     console.error("Failed to generate PDF:", error);
//     throw error;
//   }
// };

// const InfoButton = ({ setInfo }) => {
//   useMap();
//   return (
//     <div
//       style={{
//         position: "absolute",
//         bottom: "10px",
//         left: "10px",
//         padding: "8px",
//         borderRadius: "5px",
//         fontSize: "15px",
//         cursor: "pointer",
//         zIndex: 999,
//       }}
//       onMouseEnter={() => setInfo(true)}
//       onMouseLeave={() => setInfo(false)}
//     >
//       <FaCircleInfo />
//     </div>
//   );
// };

// const Hotspot = () => {
//   const [hotspotData, setHotspotData] = useState(null);
//   const [municipalityData, setMunicipalityData] = useState(null);
//   const [submunicipalityData, setSubmunicipalityData] = useState(null);
//   const [sucoData, setSucoData] = useState(null);
//   const [hotspotTable, setHotspotTable] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [info, setInfo] = useState(false);
//   const [showPdfModal, setShowPdfModal] = useState(false);
//   const [englishPdf, setEnglishPdf] = useState(null);
//   const [tetumPdf, setTetumPdf] = useState(null);
//   const containerRef = useRef(null);

//   const center = [-8.7742, 125.675]; // Timor-Leste
//   const INITIAL_VIEW_STATE = {
//     zoom: 8.5,
//   };

//   // Fetch hotspot data
//   useEffect(() => {
//     fetch("/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson")
//       .then((response) => response.json())
//       .then((data) => setHotspotData(data))
//       .catch((error) => console.error("Error loading hotspot data:", error));
//   }, []);

//   // Fetch municipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm1_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setMunicipalityData(data))
//       .catch((error) => console.error("Error loading municipality data:", error));
//   }, []);

//   // Fetch submunicipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm2_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSubmunicipalityData(data))
//       .catch((error) => console.error("Error loading submunicipality data:", error));
//   }, []);

//   // Fetch suco data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm3_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSucoData(data))
//       .catch((error) => console.error("Error loading suco data:", error));
//   }, []);

//   // Process hotspot data to build the table
//   useEffect(() => {
//     if (hotspotData && sucoData && submunicipalityData && municipalityData) {
//       const tableData = hotspotData.features.map((hotspot) => {
//         const centroid = turf.centroid(hotspot);

//         let sucoName = "Unknown";
//         let submunicipalityName = "Unknown";
//         let municipalityName = "Unknown";

//         const sucoFeature = sucoData.features.find((suco) =>
//           turf.booleanPointInPolygon(centroid, suco)
//         );
//         if (sucoFeature && sucoFeature.properties) {
//           sucoName = sucoFeature.properties.ADM3 || "Unknown";

//           const sucoCentroid = turf.centroid(sucoFeature);
//           const submunicipalityFeature = submunicipalityData.features.find((sub) =>
//             turf.booleanPointInPolygon(sucoCentroid, sub)
//           );
//           if (submunicipalityFeature && submunicipalityFeature.properties) {
//             submunicipalityName = submunicipalityFeature.properties.ADM2 || "Unknown";

//             const subCentroid = turf.centroid(submunicipalityFeature);
//             const municipalityFeature = municipalityData.features.find((mun) =>
//               turf.booleanPointInPolygon(subCentroid, mun)
//             );
//             if (municipalityFeature && municipalityFeature.properties) {
//               municipalityName = municipalityFeature.properties.ADM1 || "Unknown";
//             }
//           }
//         }

//         return {
//           suco: sucoName,
//           submunicipality: submunicipalityName,
//           municipality: municipalityName,
//           risk: hotspot.properties.risk || "Unknown",
//         };
//       });
//       setHotspotTable(tableData);
//     }
//   }, [hotspotData, sucoData, submunicipalityData, municipalityData]);

//   // Handle PDF generation and preview
//   const generateReports = async () => {
//     const containerElement = containerRef.current;
//     if (!containerElement || !hotspotTable.length) {
//       console.warn("Cannot generate report: container or hotspotTable missing");
//       alert("Cannot generate report: Data is missing.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const dataUrl = await domtoimage.toPng(containerElement, {
//         width: containerElement.offsetWidth,
//         height: containerElement.offsetHeight,
//         style: { background: "white" },
//         quality: 0.95,
//       });

//       // Generate both PDFs
//       const englishPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "en");
//       const tetumPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "tetum");

//       setEnglishPdf(englishPdfBlob);
//       setTetumPdf(tetumPdfBlob);
//       setShowPdfModal(true);
//     } catch (error) {
//       console.error("Failed to capture image or generate PDFs:", error);
//       alert("Failed to generate PDFs. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle download of both PDFs
//   const handleDownload = () => {
//     if (englishPdf && tetumPdf) {
//       saveAs(englishPdf, "DRRDSS-Hotspot-Advisory-English.pdf");
//       saveAs(tetumPdf, "DRRDSS-Hotspot-Advisory-Tetum.pdf");
//     } else {
//       alert("PDFs are not ready for download.");
//     }
//   };

//   // Handle cancel
//   const handleCancel = () => {
//     setShowPdfModal(false);
//     setEnglishPdf(null);
//     setTetumPdf(null);
//   };

//   // Styles for GeoJSON layers
//   const hotspotStyle = {
//     color: "red",
//     weight: 2,
//     fillColor: "red",
//     fillOpacity: 0.9,
//   };

//   const municipalityStyle = {
//     color: "black",
//     weight: 0.5,
//     fillColor: "blue",
//     fillOpacity: 0.0,
//   };

//   const submunicipalityStyle = {
//     color: "green",
//     weight: 2,
//     fillColor: "green",
//     fillOpacity: 0.0,
//   };

//   const sucoStyle = {
//     color: "black",
//     weight: 1,
//     fillColor: "gray",
//     fillOpacity: 0.1,
//   };

//   // Handle feature interactions
//   const onEachHotspotFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `
//         <b>Hotspot</b><br>
//         ID: ${feature.id || "Unknown"}<br>
//         Risk: ${feature.properties.risk || "Unknown"}<br>
//         Count: ${feature.properties.count || "Unknown"}
//       `;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachMunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSubmunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSucoFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   return (
//     <>
//       <button
//         onClick={generateReports}
//         disabled={loading}
//         style={{
//           padding: "4px 6px",
//           borderRadius: "6px",
//           backgroundColor: "blue",
//           color: "#333333",
//           marginBottom: "5px",
//           marginLeft: "87%",
//           top: "0px",
//           right: "0px",
//           border: "none",
//         }}
//       >
//         {loading ? "Generating..." : "Generate Report"}
//       </button>
//       {showPdfModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "flex-start",
//             paddingTop: "20px",
//             zIndex: 9999,
//             overflow: "auto",
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "12px",
//               padding: "24px",
//               maxWidth: "90%",
//               width: "1000px",
//               boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <div style={{ display: "flex", gap: "20px", justifyContent: "space-between" }}>
//               <div style={{ flex: 1, textAlign: "center" }}>
//                 <h3 style={{ marginBottom: "10px", fontSize: "16px", color: "#333" }}>English PDF</h3>
//                 {englishPdf && (
//                   <iframe
//                     src={URL.createObjectURL(englishPdf)}
//                     style={{ width: "100%", height: "500px", border: "1px solid #ccc" }}
//                     title="English PDF Preview"
//                   />
//                 )}
//               </div>
//               <div style={{ flex: 1, textAlign: "center" }}>
//                 <h3 style={{ marginBottom: "10px", fontSize: "16px", color: "#333" }}>Tetum PDF</h3>
//                 {tetumPdf && (
//                   <iframe
//                     src={URL.createObjectURL(tetumPdf)}
//                     style={{ width: "100%", height: "500px", border: "1px solid #ccc" }}
//                     title="Tetum PDF Preview"
//                   />
//                 )}
//               </div>
//             </div>
//             <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
//               <button
//                 onClick={handleDownload}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#007bff",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                   transition: "background-color 0.2s",
//                 }}
//               >
//                 Download Both PDFs
//               </button>
//               <button
//                 onClick={handleCancel}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#6c757d",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                   transition: "background-color 0.2s",
//                 }}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="hotspot-container" ref={containerRef}>
//         <MapContainer
//           center={center}
//           zoom={INITIAL_VIEW_STATE.zoom}
//           style={{ height: "75vh", width: "100%" }}
//         >
//           <TileLayer
//             url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
//             attribution="Tiles © Esri — Esri, DeLorme, NAVTEQ"
//           />
//           <LayersControl position="topright">
//             {hotspotData && (
//               <LayersControl.Overlay name="Hotspots" checked>
//                 <GeoJSON
//                   data={hotspotData}
//                   style={hotspotStyle}
//                   onEachFeature={onEachHotspotFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {municipalityData && (
//               <LayersControl.Overlay name="Municipalities" checked>
//                 <GeoJSON
//                   data={municipalityData}
//                   style={municipalityStyle}
//                   onEachFeature={onEachMunicipalityFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {submunicipalityData && (
//               <LayersControl.Overlay name="Submunicipalities">
//                 <GeoJSON
//                   data={submunicipalityData}
//                   style={submunicipalityStyle}
//                   onEachFeature={onEachSubmunicipalityFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {sucoData && (
//               <LayersControl.Overlay name="Sucos">
//                 <GeoJSON
//                   data={sucoData}
//                   style={sucoStyle}
//                   onEachFeature={onEachSucoFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//           </LayersControl>
//           <div
//             style={{
//               position: "absolute",
//               bottom: "2px",
//               right: "2px",
//               background: "white",
//               padding: "10px",
//               border: "1px solid #ccc",
//               zIndex: 1000,
//             }}
//           >
//             <LegendItem color="rgba(255, 0, 0, 1)" label="Hotspots" />
//           </div>
//           {info && (
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "13px",
//                 left: "35px",
//                 fontSize: "12px",
//                 zIndex: 1000,
//                 backgroundColor: "white",
//                 padding: "5px",
//                 borderRadius: "5px",
//                 boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//               }}
//             >
//               72 hour hotspot information based on latest data is available from NDVI, LST.
//             </div>
//           )}
//           <InfoButton setInfo={setInfo} />
//         </MapContainer>
//       </div>
//     </>
//   );
// };

// const LegendItem = ({ color, label }) => (
//   <div style={{ marginBottom: "5px" }}>
//     <span
//       style={{
//         display: "inline-block",
//         width: "20px",
//         height: "10px",
//         background: color,
//         marginRight: "5px",
//       }}
//     ></span>
//     {label}
//   </div>
// );

// export default Hotspot;



// import React, { useEffect, useState, useRef } from "react";
// import { MapContainer, TileLayer, GeoJSON, LayersControl, useMap } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import * as turf from "@turf/turf";
// import domtoimage from "dom-to-image";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import { FaPlusCircle, FaEdit, FaTrash } from "react-icons/fa";
// import { FaCircleInfo } from "react-icons/fa6";// ✅ Most commonly used info icon

// import { saveAs } from "file-saver";

// // Initial translations (same as original)
// const initialTranslations = {
//   en: {
//     title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
//     warningTitle: "Fire Hotspots Advisory for Timor-Leste",
//     advisoryNumber: "Advisory number: ",
//     issuedBy: "Issued by:",
//     issuedAt: "Date & Time:",
//     overview: "Overview",
//     highRiskWarning: "A forecast has been issued for high fire risk hotspots in several sucos within [highRiskMunicipalities]. Immediate precautions are recommended to prevent fire outbreaks.",
//     mapHeading: "Fire Hotspot Risk Map",
//     tableHeaders: ["Municipality", "Sub-Municipality", "Suco", "Risk Level"],
//     generalAdvisory: "General Advisory",
//     advisoryIntro: "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and prevent fire outbreaks:",
//     advisoryTableHeaders: ["Type", "Advisory"],
//     advisoryPoints: [
//       {
//         type: "Do's",
//         points: [
//           "Secure flammable materials away from heat-prone areas.",
//           "Ensure any outdoor fire or heat-producing activity is fully extinguished before leaving."
//         ]
//       },
//       {
//         type: "Don'ts",
//         points: [
//           "Do not light fires or burn waste near vegetation or dry areas.",
//           "Do not engage in open burning activities during high heat periods.",
//           "Avoid entering high-risk areas without proper protective gear or local clearance."
//         ]
//       },
//       {
//         type: "Prevention and Preparedness",
//         points: [
//           "Keep emergency contact numbers of fire services and local authorities easily accessible.",
//           "Report any visible smoke, fire, or abnormal heat activity immediately.",
//           "Avoid outdoor activities that may trigger sparks or fires, such as welding or fireworks near dry vegetation.",
//           "Use lanterns, stoves, and heaters with caution in high-risk zones. Ensure equipment is cool before refueling.",
//           "Dispose of smoking materials like cigarettes safely and away from dry areas.",
//           "Do not burn agricultural, industrial, or municipal waste near hotspot regions.",
//           "Prepare and maintain defensible space around homes in at-risk zones by clearing dry debris and combustibles.",
//           "Ensure availability of emergency kits and pre-plan evacuation routes.",
//           "Conduct preparedness drills regularly and identify safe zones in your community."
//         ]
//       },
//       {
//         type: "Evacuation in Case of Extreme Heat or Fire Hotspot Escalation",
//         points: [
//           "Evacuate immediately upon advisories from local authorities or emergency services.",
//           "Protect yourself from heat exposure and possible airborne particles.",
//           "Secure your animals and assist vulnerable individuals during evacuation."
//         ]
//       },
//       {
//         type: "Before Leaving Your House",
//         points: [
//           "Remove all combustible items like gas cylinders, firewood, and dry waste from your surroundings.",
//           "Seal windows, vents, and doors to minimize smoke or heat intrusion.",
//           "Store water in large containers to use in case of emergency cooling.",
//           "Trim dry plants and clean debris around your property to reduce ignition risk.",
//           "Inspect and clean rooftops, gutters, and drainage areas regularly.",
//           "Dampen roofs and exterior walls if advised by emergency services during high-risk alerts."
//         ]
//       },
//       {
//         type: "If Exposed to a Hotspot While Outdoors",
//         points: [
//           "Avoid attempting to outrun fire or heat. Seek refuge in a cleared, low-vegetation area.",
//           "Cover your nose and mouth with a wet cloth to reduce smoke inhalation risk.",
//           "Use water, soil, or nonflammable materials to shield yourself if surrounded by heat or fire."
//         ]
//       },
//       {
//         type: "If Sheltering at Home During a Heat Alert or Hotspot Activation",
//         points: [
//           "Stay calm and indoors. Seal your home to prevent heat and smoke entry.",
//           "Avoid opening hot doors — it may indicate fire or intense heat on the other side.",
//           "Monitor official updates for when it's safe to evacuate or step out."
//         ]
//       },
//       {
//         type: "If Caught in a Vehicle in a Hotspot-Affected Area",
//         points: [
//           "Stay inside the vehicle — it offers better protection than open space.",
//           "Keep windows and air vents closed to avoid smoke and heat exposure.",
//           "Drive cautiously with headlights on and remain alert to surroundings.",
//           "If stopping, park away from vegetation and turn off the engine.",
//           "Stay low inside the vehicle and cover yourself with nonflammable material."
//         ]
//       }
//     ],
//     noteLabel: "Note:",
//     noteText: "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
//     footer: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
//     page: "Page [i] of [pageCount]",
//   },
//   tetum: {
//     title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
//     warningTitle: "Avisu kona ba Rai Manas iha Timor-Leste",
//     advisoryNumber: "Númeru Aviso:",
//     issuedBy: "Ema-husik husi:",
//     issuedAt: "Data no Oras:",
//     overview: "VISAUN JERAL",
//     highRiskWarning: "Forescast ida ema-husik ona kona-ba risku foho altus iha suco balun iha [highRiskMunicipalities]. Rekomenda prevensaun imediata atu prevene foho.",
//     mapHeading: "MAPA RISKU HOTSPOT FOHO",
//     tableHeaders: ["Munisípiu", "Sub-munisípiu", "Suco", "Nivel Risku"],
//     generalAdvisory: "KONSELLU JERAL",
//     advisoryIntro: "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no prevene foho:",
//     advisoryTableHeaders: ["Tipu", "Konsellu"],
//     advisoryPoints: [
//       {
//         type: "Diak Halo",
//         points: [
//           "Tau hela materiál sira ne'ebé bele haksolok fatin hela toos no manas.",
//           "Konfirma katak hela-fatin ne'ebé manas ka iha api, sei la iha risku fatin molok ita halai."
//         ]
//       },
//       {
//         type: "Labele Halo",
//         points: [
//           "Labele sunu ai-ruin ka lixu besik toos ka fatin matak.",
//           "Labele halo sunu iha loron ne'ebé manas tebes.",
//           "Labele tama iha fatin risku boot tan manas boot la'ós ho proteksaun loos ka klaru husi autoridade lokal."
//         ]
//       },
//       {
//         type: "Prevensaun no Preparasaun",
//         points: [
//           "Tau hela numeru kontaktu emergencia hosi servisu bombeiru no autoridade lokal.",
//           "Hatete lalais ba autoridade se haree sukun, api, ka manas boot ne'ebé la normal.",
//           "Labele halo atividade iha liur ne'ebé bele halo iskra ka api, hanesan soldadura ka fogu d'artifísiu besik ai matak.",
//           "Uza lanterna, fogão, no aparato manas ho atensaun iha fatin manas. Labele tau gasolina antes ne'ebé aparatu cool.",
//           "Hamoos sigaru, fósforu, no materiál fumar iha fatin ne'ebé seguru, labele hikas iha fatin matak.",
//           "Labele sunu restu agrikultura, indústria ka lixu municipal besik hotspot.",
//           "Hamoos ai-ruin matak no materiál haksolok iha zona risku, prepara área seguransa iha entorno uma.",
//           "Prepara hela kit emergencia no buat sira ne'ebé importante ba evacuasaun.",
//           "Halo simulasaun evacuasaun no hatene fatin seguransa iha komunidade."
//         ]
//       },
//       {
//         type: "Evakuasaun iha tempu manas ka eskalasaun hotspot",
//         points: [
//           "Sai hela fatin tan dehan hosi autoridade lokal ka servisu emergencia.",
//           "Proteje-an hosi manas tebes no partículas iha ar.",
//           "Toman konta animal sira no ajuda ema matak ka ema ne'ebé iha nesesidade espesiál."
//         ]
//       },
//       {
//         type: "Molok Sai husi Uma",
//         points: [
//           "Taka no hasai buat hotu ne'ebé haksolok hanesan botija gas, ai-ruin, no lixu matak iha entorno uma.",
//           "Taka janela, ventilasaun no odamatan atu prevene fumaça ka manas tama.",
//           "Tau bee iha vasilha boot atu uza ba manan manas ka fumaça.",
//           "Kose ai-ruin matak no halo limpu zona iha nia sorin uma.",
//           "Hamoos telhado, kalha no fatin saluran bee.",
//           "Tau bee iha telhado, paredes no ai sira iha sorin uma karik iha alerta hosi autoridade."
//         ]
//       },
//       {
//         type: "Se Ita iha Liur iha Fatin Hotspot",
//         points: [
//           "Labele halai atu la'o husi api. Bolu hela iha fatin ne'ebé matak no buka área klaru.",
//           "Kobre-an ho kanuru molik atu prevene fumaça tama iha matan no anin.",
//           "Uza bee, rai, ka materiál ne'ebé la bele sunu atu proteje-an se iha risku boot iha fatin."
//         ]
//       },
//       {
//         type: "Se Ita iha Uma Durante Alerta Hotspot",
//         points: [
//           "Tuir diak, hela iha uma. Taka buat hotu atu prevene fumaça ka manas tama.",
//           "Se odamatan manas tebes, labele taka tan bele iha api iha fatin seluk.",
//           "Tuir informasaun ofisiál ba tempu ne'ebé seguru atu sai ka evacuate."
//         ]
//       },
//       {
//         type: "Se Ita iha Karreta iha Fatin Hotspot",
//         points: [
//           "Hela iha laran karreta — liu seguru liu dukur iha liur.",
//           "Taka janela no ventilasaun atu prevene fumaça ka manas tama.",
//           "La'o ho kuidadu no laran moris iha luz karreta.",
//           "Se presiza para: para iha fatin ne'ebé laduun iha vegetasaun, taka motor.",
//           "Hela iha laran karreta no tuun ba rai.",
//           "Kobre-an ho ropa ka materiál ne'ebé la bele sunu."
//         ]
//       }
//     ],
//     noteLabel: "Nota:",
//     noteText: "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
//     footer: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
//     page: "Pajina [i] husi [pageCount]",
//   },
// };

// // Risk level translations
// const riskLevelTranslations = {
//   en: { 3: "High Risk" },
//   tetum: { 3: "Risku Altus" },
// };

// // Helper function to load images
// const loadImage = (src) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = "Anonymous";
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = src;
//   });
// };

// // Helper function to add banner to a page
// const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
//   const bannerHeight = 20; // Height in mm
//   const bannerWidth = pageWidth - 2 * sideMargin; // Span page width minus margins
//   if (bannerImage) {
//     pdf.addImage(
//       bannerImage,
//       "PNG",
//       sideMargin,
//       topMargin,
//       bannerWidth,
//       bannerHeight
//     );
//   }
//   return topMargin + bannerHeight + 5; // Return new currentY (5mm gap)
// };

// // Function to generate PDF and return as Blob
// const generatePdfWithImage = async (dataUrl, hotspotTable, municipalityData, language = "en", translations) => {
//   try {
//     const pdf = new jsPDF("portrait", "mm", "a4");
//     const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm
//     const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
//     const sideMargin = 10;
//     const topMargin = 10;
//     const footerHeight = 10;
//     const marginBottom = 10;
//     const bannerHeight = 20; // Assumed banner height
//     const headerHeight = topMargin + bannerHeight + 5; // 35 mm (10 + 20 + 5)
//     const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom; // ~242 mm
//     let currentY;

//     const t = translations[language];
//     const riskT = riskLevelTranslations[language];

//     // Load banner image based on language
//     let bannerImage;
//     const bannerPath = language === "en" ? "/pdf/banner.png" : "/pdf/tetumbanner.png";
//     try {
//       bannerImage = await loadImage(bannerPath);
//     } catch (error) {
//       console.warn(`Failed to load ${bannerPath}:`, error);
//       bannerImage = null;
//     }

//     // Helper function to add page with header
//     const addPageWithHeader = () => {
//       pdf.addPage();
//       return addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     };

//     // Add banner to first page
//     currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     currentY += 5;

//     // Add warning title
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 0, 0);
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.text(t.warningTitle, pageWidth / 2, currentY, { align: "center" });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 10;

//     // Format date in Asia/Dili timezone
//     const now = new Date();
//     const formattedDate = new Intl.DateTimeFormat("en-GB", {
//       timeZone: "Asia/Dili",
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     }).format(now);

//     const [datePart, timePartRaw] = formattedDate.split(", ");
//     const [day, month, year] = datePart.split("/");
//     const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
//     const [_, hour, minute, second, period] = timeMatch;
//     const formattedTimorDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;

//     pdf.setFontSize(10);

//     // Ensure enough space, else add page
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }

//     // Prepare left and right text with bold labels
//     pdf.setFont("helvetica", "bold");
//     const advisoryNumberLabel = t.advisoryNumber;
//     pdf.text(advisoryNumberLabel, sideMargin, currentY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(t.advisoryNumberValue || "1", sideMargin + pdf.getTextWidth(advisoryNumberLabel) + 2, currentY);
//     pdf.setFont("helvetica", "bold");
//     const issuedAtLabel = t.issuedAt;
//     const rightText = `${issuedAtLabel} ${t.issuedAtValue || formattedTimorDate}`;
//     const rightTextWidth = pdf.getTextWidth(rightText);
//     const rightX = pageWidth - sideMargin - rightTextWidth;
//     pdf.text(issuedAtLabel, rightX, currentY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(t.issuedAtValue || formattedTimorDate, rightX + pdf.getTextWidth(issuedAtLabel) + 2, currentY);
//     currentY += 6;

//     // Issued by
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont("helvetica", "bold");
//     const issuedByLabel = t.issuedBy;
//     pdf.text(issuedByLabel, sideMargin, currentY);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(t.issuedByValue || "Department of Meteorology", sideMargin + pdf.getTextWidth(issuedByLabel) + 2, currentY);
//     currentY += 6;

//     currentY += 5;

//     // Identify high-risk municipalities
//     const highRiskMunicipalities = [...new Set(
//       hotspotTable
//         .filter((row) => row.risk >= 3)
//         .map((row) => row.municipality)
//     )].join(", ") || (language === "en" ? "No high-risk areas identified" : "Laiha fatin ho risku altus identifika");

//     currentY += 5;

//     // OVERVIEW section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239); // Background color (light blue)
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
//     pdf.setTextColor(0, 0, 0); // Black text
//     pdf.text(t.overview, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
//     pdf.setTextColor(0, 0, 0); // Reset text color
//     currentY += 10;

//     // Warning message
//     const warningText = [t.highRiskWarning.replace("[highRiskMunicipalities]", highRiskMunicipalities)];
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "normal");
//     warningText.forEach((line) => {
//       const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
//       lines.forEach((splitLine) => {
//         if (currentY + 6 > availablePageHeight + headerHeight) {
//           currentY = addPageWithHeader();
//         }
//         pdf.text(splitLine, sideMargin, currentY);
//         currentY += 6;
//       });
//       currentY += 2;
//     });
//     currentY += 5;

//     currentY += 2;

//     // MAP heading
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239); // Background color (light blue)
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
//     pdf.setTextColor(0, 0, 0); // Black text
//     pdf.text(t.mapHeading, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
//     pdf.setTextColor(0, 0, 0); // Reset text color
//     currentY += 5;

//     // Add map image
//     if (dataUrl) {
//       const img = await loadImage(dataUrl);
//       const availableWidth = pageWidth - 2 * sideMargin;
//       const imgHeight = (img.height * availableWidth) / img.width;

//       if (currentY + imgHeight + 5 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }

//       pdf.addImage(dataUrl, "PNG", sideMargin, currentY, availableWidth, imgHeight);
//       currentY += imgHeight + 5;
//     } else {
//       console.warn("No map image provided for PDF");
//     }
//     currentY += 5;

//     // Prepare table data
//     const tableData = hotspotTable.map((row) => [
//       row.municipality,
//       row.submunicipality,
//       row.suco,
//       riskT[row.risk] || row.risk,
//     ]);

//     // Add table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.tableHeaders],
//       body: tableData,
//       theme: "grid",
//       headStyles: { fillColor: [225, 232, 242], halign: "left", fontStyle: "bold", textColor: "black" },
//       styles: { fontSize: 9, cellPadding: 3 },
//       columnStyles: {
//         0: { cellWidth: 40 },
//         1: { cellWidth: 40 },
//         2: { cellWidth: 40 },
//         3: { cellWidth: 40 },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });

//     currentY += 5;

//     // GENERAL ADVISORY section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFillColor(202, 217, 239);
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F");
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(t.generalAdvisory, sideMargin + 2, currentY - 1, { align: "left" });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 7;

//     currentY += 5;

//     // Add advisory intro
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "normal");
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     const introLines = pdf.splitTextToSize(t.advisoryIntro, pageWidth - 2 * sideMargin);
//     introLines.forEach((line) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });

//     currentY += 5;

//     // Prepare table data for advisory with bullet points
//     const advisoryTableData = t.advisoryPoints.map((category) => [
//       category.type,
//       category.points.map((point) => `• ${point}`).join("\n")
//     ]);

//     // Add advisory table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.advisoryTableHeaders],
//       body: advisoryTableData,
//       theme: "grid",
//       headStyles: {
//         fillColor: [225, 232, 242],
//         halign: "left",
//         fontStyle: "bold",
//         textColor: "black",
//       },
//       styles: {
//         fontSize: 9,
//         cellPadding: { top: 3, right: 3, bottom: 3, left: 5 },
//         overflow: "linebreak",
//         lineHeight: 1.2,
//       },
//       columnStyles: {
//         0: { cellWidth: 40, halign: "left" },
//         1: { cellWidth: pageWidth - 2 * sideMargin - 40, halign: "left" },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });

//     currentY += 5;

//     // Add Note section
//     if (currentY + 12 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(10);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(t.noteLabel, sideMargin, currentY);
//     currentY += 6;
//     pdf.setFont("helvetica", "normal");
//     const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
//     noteLines.forEach((line) => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });
//     currentY += 4;

//     currentY += 12;

//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont("helvetica", "bold");
//     pdf.text("*****", (pageWidth - pdf.getTextWidth("*****")) / 2, currentY);
//     currentY += 6;
//     pdf.setFont("helvetica", "normal");

//     // Add footer to all pages
//     const pageCount = pdf.internal.getNumberOfPages();
//     const footerYOffset = 5;
//     for (let i = 1; i <= pageCount; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(8);
//       pdf.text(
//         t.footer,
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset - 2,
//         { align: "center" }
//       );
//       pdf.text(
//         t.page.replace("[i]", i).replace("[pageCount]", pageCount),
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset + 3,
//         { align: "center" }
//       );
//     }

//     // Return PDF as Blob
//     return pdf.output("blob");
//   } catch (error) {
//     console.error("Failed to generate PDF:", error);
//     throw error;
//   }
// };

// const InfoButton = ({ setInfo }) => {
//   useMap();
//   return (
//     <div
//       style={{
//         position: "absolute",
//         bottom: "10px",
//         left: "10px",
//         padding: "8px",
//         borderRadius: "5px",
//         fontSize: "15px",
//         cursor: "pointer",
//         zIndex: 999,
//       }}
//       onMouseEnter={() => setInfo(true)}
//       onMouseLeave={() => setInfo(false)}
//     >
//       <FaCircleInfo />
//     </div>
//   );
// };

// const Hotspot = () => {
//   const [hotspotData, setHotspotData] = useState(null);
//   const [municipalityData, setMunicipalityData] = useState(null);
//   const [submunicipalityData, setSubmunicipalityData] = useState(null);
//   const [sucoData, setSucoData] = useState(null);
//   const [hotspotTable, setHotspotTable] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [info, setInfo] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showPdfModal, setShowPdfModal] = useState(false);
//   const [englishPdf, setEnglishPdf] = useState(null);
//   const [tetumPdf, setTetumPdf] = useState(null);
//   const [translations, setTranslations] = useState(initialTranslations);
//   const [editAdvisory, setEditAdvisory] = useState({ lang: "", index: null, pointIndex: null, value: "" });
//   const containerRef = useRef(null);

//   const center = [-8.7742, 125.675]; // Timor-Leste
//   const INITIAL_VIEW_STATE = {
//     zoom: 8.5,
//   };

//   // Fetch hotspot data
//   useEffect(() => {
//     fetch("/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson")
//       .then((response) => response.json())
//       .then((data) => setHotspotData(data))
//       .catch((error) => console.error("Error loading hotspot data:", error));
//   }, []);

//   // Fetch municipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm1_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setMunicipalityData(data))
//       .catch((error) => console.error("Error loading municipality data:", error));
//   }, []);

//   // Fetch submunicipality data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm2_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSubmunicipalityData(data))
//       .catch((error) => console.error("Error loading submunicipality data:", error));
//   }, []);

//   // Fetch suco data
//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm3_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSucoData(data))
//       .catch((error) => console.error("Error loading suco data:", error));
//   }, []);

//   // Process hotspot data to build the table
//   useEffect(() => {
//     if (hotspotData && sucoData && submunicipalityData && municipalityData) {
//       const tableData = hotspotData.features.map((hotspot) => {
//         const centroid = turf.centroid(hotspot);

//         let sucoName = "Unknown";
//         let submunicipalityName = "Unknown";
//         let municipalityName = "Unknown";

//         const sucoFeature = sucoData.features.find((suco) =>
//           turf.booleanPointInPolygon(centroid, suco)
//         );
//         if (sucoFeature && sucoFeature.properties) {
//           sucoName = sucoFeature.properties.ADM3 || "Unknown";

//           const sucoCentroid = turf.centroid(sucoFeature);
//           const submunicipalityFeature = submunicipalityData.features.find((sub) =>
//             turf.booleanPointInPolygon(sucoCentroid, sub)
//           );
//           if (submunicipalityFeature && submunicipalityFeature.properties) {
//             submunicipalityName = submunicipalityFeature.properties.ADM2 || "Unknown";

//             const subCentroid = turf.centroid(submunicipalityFeature);
//             const municipalityFeature = municipalityData.features.find((mun) =>
//               turf.booleanPointInPolygon(subCentroid, mun)
//             );
//             if (municipalityFeature && municipalityFeature.properties) {
//               municipalityName = municipalityFeature.properties.ADM1 || "Unknown";
//             }
//           }
//         }

//         return {
//           suco: sucoName,
//           submunicipality: submunicipalityName,
//           municipality: municipalityName,
//           risk: hotspot.properties.risk || "Unknown",
//         };
//       });
//       setHotspotTable(tableData);
//     }
//   }, [hotspotData, sucoData, submunicipalityData, municipalityData]);

//   // Handle input changes for text fields
//   const handleInputChange = (lang, field, value) => {
//     setTranslations((prev) => ({
//       ...prev,
//       [lang]: {
//         ...prev[lang],
//         [field]: value,
//       },
//     }));
//   };

//   // Handle adding new advisory type
//   const handleAddAdvisoryType = (lang) => {
//     setTranslations((prev) => ({
//       ...prev,
//       [lang]: {
//         ...prev[lang],
//         advisoryPoints: [
//           ...prev[lang].advisoryPoints,
//           { type: "New Advisory Type", points: [] },
//         ],
//       },
//     }));
//   };

//   // Handle editing advisory type
//   const handleEditAdvisoryType = (lang, index, value) => {
//     setTranslations((prev) => {
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[index] = { ...newAdvisoryPoints[index], type: value };
//       return {
//         ...prev,
//         [lang]: {
//           ...prev[lang],
//           advisoryPoints: newAdvisoryPoints,
//         },
//       };
//     });
//   };

//   // Handle adding advisory point
//   const handleAddAdvisoryPoint = (lang, index) => {
//     setTranslations((prev) => {
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[index].points.push("New Advisory Point");
//       return {
//         ...prev,
//         [lang]: {
//           ...prev[lang],
//           advisoryPoints: newAdvisoryPoints,
//         },
//       };
//     });
//   };

//   // Handle editing advisory point
//   const handleEditAdvisoryPoint = (lang, index, pointIndex, value) => {
//     setTranslations((prev) => {
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[index].points[pointIndex] = value;
//       return {
//         ...prev,
//         [lang]: {
//           ...prev[lang],
//           advisoryPoints: newAdvisoryPoints,
//         },
//       };
//     });
//   };

//   // Handle deleting advisory point
//   const handleDeleteAdvisoryPoint = (lang, index, pointIndex) => {
//     setTranslations((prev) => {
//       const newAdvisoryPoints = [...prev[lang].advisoryPoints];
//       newAdvisoryPoints[index].points.splice(pointIndex, 1);
//       return {
//         ...prev,
//         [lang]: {
//           ...prev[lang],
//           advisoryPoints: newAdvisoryPoints,
//         },
//       };
//     });
//   };

//   // Handle generate reports
//   const generateReports = async () => {
//     const containerElement = containerRef.current;
//     if (!containerElement || !hotspotTable.length) {
//       console.warn("Cannot generate report: container or hotspotTable missing");
//       alert("Cannot generate report: Data is missing.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const dataUrl = await domtoimage.toPng(containerElement, {
//         width: containerElement.offsetWidth,
//         height: containerElement.offsetHeight,
//         style: { background: "white" },
//         quality: 0.95,
//       });

//       // Generate both PDFs
//       const englishPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "en", translations);
//       const tetumPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "tetum", translations);

//       setEnglishPdf(englishPdfBlob);
//       setTetumPdf(tetumPdfBlob);
//       setShowPdfModal(true);
//     } catch (error) {
//       console.error("Failed to capture image or generate PDFs:", error);
//       alert("Failed to generate PDFs. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle download of both PDFs
//   const handleDownload = () => {
//     if (englishPdf && tetumPdf) {
//       saveAs(englishPdf, "DRRDSS-Hotspot-Advisory-English.pdf");
//       saveAs(tetumPdf, "DRRDSS-Hotspot-Advisory-Tetum.pdf");
//     } else {
//       alert("PDFs are not ready for download.");
//     }
//   };

//   // Handle cancel
//   const handleCancel = () => {
//     setShowPdfModal(false);
//     setEnglishPdf(null);
//     setTetumPdf(null);
//   };

//   // Handle opening edit modal
//   const handleOpenEditModal = () => {
//     setShowEditModal(true);
//   };

//   // Handle closing edit modal
//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//   };

//   // Styles for GeoJSON layers
//   const hotspotStyle = {
//     color: "red",
//     weight: 2,
//     fillColor: "red",
//     fillOpacity: 0.9,
//   };

//   const municipalityStyle = {
//     color: "black",
//     weight: 0.5,
//     fillColor: "blue",
//     fillOpacity: 0.0,
//   };

//   const submunicipalityStyle = {
//     color: "green",
//     weight: 2,
//     fillColor: "green",
//     fillOpacity: 0.0,
//   };

//   const sucoStyle = {
//     color: "black",
//     weight: 1,
//     fillColor: "gray",
//     fillOpacity: 0.1,
//   };

//   // Handle feature interactions
//   const onEachHotspotFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `
//         <b>Hotspot</b><br>
//         ID: ${feature.id || "Unknown"}<br>
//         Risk: ${feature.properties.risk || "Unknown"}<br>
//         Count: ${feature.properties.count || "Unknown"}
//       `;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachMunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSubmunicipalityFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   const onEachSucoFeature = (feature, layer) => {
//     if (feature.properties) {
//       const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || "Unknown"}`;
//       layer.bindPopup(popupContent);
//     }
//   };

//   return (
//     <>
//       <button
//         onClick={handleOpenEditModal}
//         disabled={loading}
//         style={{
//           padding: "4px 6px",
//           borderRadius: "6px",
//           backgroundColor: "blue",
//           color: "#333333",
//           marginBottom: "5px",
//           marginLeft: "87%",
//           top: "0px",
//           right: "0px",
//           border: "none",
//         }}
//       >
//         {loading ? "Generating..." : "Generate Report"}
//       </button>
//       {showEditModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "flex-start",
//             paddingTop: "20px",
//             zIndex: 9999,
//             overflow: "auto",
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "12px",
//               padding: "24px",
//               maxWidth: "90%",
//               width: "1000px",
//               boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
//               maxHeight: "80vh",
//               overflowY: "auto",
//             }}
//           >
//             <h3 style={{ marginBottom: "20px", fontSize: "18px", color: "#333" }}>
//               Edit Report Content
//             </h3>
//             <div style={{ display: "flex", gap: "20px" }}>
//               {/* English Editing */}
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ marginBottom: "10px", color: "#007bff" }}>English</h4>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Warning Title</label>
//                   <input
//                     type="text"
//                     value={translations.en.warningTitle}
//                     onChange={(e) => handleInputChange("en", "warningTitle", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Advisory Number</label>
//                   <input
//                     type="text"
//                     value={translations.en.advisoryNumberValue || "1"}
//                     onChange={(e) => handleInputChange("en", "advisoryNumberValue", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Issued By</label>
//                   <input
//                     type="text"
//                     value={translations.en.issuedByValue || "Department of Meteorology"}
//                     onChange={(e) => handleInputChange("en", "issuedByValue", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Issued At</label>
//                   <input
//                     type="text"
//                     value={translations.en.issuedAtValue || new Date().toLocaleString("en-GB", { timeZone: "Asia/Dili" })}
//                     onChange={(e) => handleInputChange("en", "issuedAtValue", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Overview</label>
//                   <input
//                     type="text"
//                     value={translations.en.overview}
//                     onChange={(e) => handleInputChange("en", "overview", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>High Risk Warning</label>
//                   <textarea
//                     value={translations.en.highRiskWarning}
//                     onChange={(e) => handleInputChange("en", "highRiskWarning", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minHeight: "80px" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>General Advisory</label>
//                   <input
//                     type="text"
//                     value={translations.en.generalAdvisory}
//                     onChange={(e) => handleInputChange("en", "generalAdvisory", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Advisory Intro</label>
//                   <textarea
//                     value={translations.en.advisoryIntro}
//                     onChange={(e) => handleInputChange("en", "advisoryIntro", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minHeight: "80px" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Advisory Points</label>
//                   {translations.en.advisoryPoints.map((category, index) => (
//                     <div key={index} style={{ marginBottom: "15px", padding: "10px", border: "1px solid #eee", borderRadius: "4px" }}>
//                       <input
//                         type="text"
//                         value={category.type}
//                         onChange={(e) => handleEditAdvisoryType("en", index, e.target.value)}
//                         style={{ width: "100%", padding: "8px", marginBottom: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
//                       />
//                       {category.points.map((point, pointIndex) => (
//                         <div key={pointIndex} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
//                           {editAdvisory.lang === "en" && editAdvisory.index === index && editAdvisory.pointIndex === pointIndex ? (
//                             <input
//                               type="text"
//                               value={editAdvisory.value}
//                               onChange={(e) => setEditAdvisory({ ...editAdvisory, value: e.target.value })}
//                               onBlur={() => {
//                                 handleEditAdvisoryPoint("en", index, pointIndex, editAdvisory.value);
//                                 setEditAdvisory({ lang: "", index: null, pointIndex: null, value: "" });
//                               }}
//                               style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                             />
//                           ) : (
//                             <span style={{ flex: 1 }}>{point}</span>
//                           )}
//                           <FaEdit
//                             style={{ marginLeft: "10px", cursor: "pointer", color: "#007bff" }}
//                             onClick={() => setEditAdvisory({ lang: "en", index, pointIndex, value: point })}
//                           />
//                           <FaTrash
//                             style={{ marginLeft: "10px", cursor: "pointer", color: "#dc3545" }}
//                             onClick={() => handleDeleteAdvisoryPoint("en", index, pointIndex)}
//                           />
//                         </div>
//                       ))}
//                       <button
//                         onClick={() => handleAddAdvisoryPoint("en", index)}
//                         style={{ padding: "5px 10px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "4px", marginTop: "5px" }}
//                       >
//                         Add Point
//                       </button>
//                     </div>
//                   ))}
//                   <FaPlusCircle
//                     style={{ color: "#28a745", fontSize: "20px", cursor: "pointer", marginTop: "10px" }}
//                     onClick={() => handleAddAdvisoryType("en")}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Note Label</label>
//                   <input
//                     type="text"
//                     value={translations.en.noteLabel}
//                     onChange={(e) => handleInputChange("en", "noteLabel", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Note Text</label>
//                   <textarea
//                     value={translations.en.noteText}
//                     onChange={(e) => handleInputChange("en", "noteText", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minHeight: "80px" }}
//                   />
//                 </div>
//               </div>
//               {/* Tetum Editing */}
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ marginBottom: "10px", color: "#28a745" }}>Tetum</h4>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Warning Title</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.warningTitle}
//                     onChange={(e) => handleInputChange("tetum", "warningTitle", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Advisory Number</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.advisoryNumberValue || "1"}
//                     onChange={(e) => handleInputChange("tetum", "advisoryNumberValue", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Issued By</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.issuedByValue || "Department of Meteorology"}
//                     onChange={(e) => handleInputChange("tetum", "issuedByValue", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Issued At</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.issuedAtValue || new Date().toLocaleString("en-GB", { timeZone: "Asia/Dili" })}
//                     onChange={(e) => handleInputChange("tetum", "issuedAtValue", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Overview</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.overview}
//                     onChange={(e) => handleInputChange("tetum", "overview", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>High Risk Warning</label>
//                   <textarea
//                     value={translations.tetum.highRiskWarning}
//                     onChange={(e) => handleInputChange("tetum", "highRiskWarning", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minHeight: "80px" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>General Advisory</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.generalAdvisory}
//                     onChange={(e) => handleInputChange("tetum", "generalAdvisory", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Advisory Intro</label>
//                   <textarea
//                     value={translations.tetum.advisoryIntro}
//                     onChange={(e) => handleInputChange("tetum", "advisoryIntro", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minHeight: "80px" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Advisory Points</label>
//                   {translations.tetum.advisoryPoints.map((category, index) => (
//                     <div key={index} style={{ marginBottom: "15px", padding: "10px", border: "1px solid #eee", borderRadius: "4px" }}>
//                       <input
//                         type="text"
//                         value={category.type}
//                         onChange={(e) => handleEditAdvisoryType("tetum", index, e.target.value)}
//                         style={{ width: "100%", padding: "8px", marginBottom: "10px", borderRadius: "4px", border: "1px solid #ccc" }}
//                       />
//                       {category.points.map((point, pointIndex) => (
//                         <div key={pointIndex} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
//                           {editAdvisory.lang === "tetum" && editAdvisory.index === index && editAdvisory.pointIndex === pointIndex ? (
//                             <input
//                               type="text"
//                               value={editAdvisory.value}
//                               onChange={(e) => setEditAdvisory({ ...editAdvisory, value: e.target.value })}
//                               onBlur={() => {
//                                 handleEditAdvisoryPoint("tetum", index, pointIndex, editAdvisory.value);
//                                 setEditAdvisory({ lang: "", index: null, pointIndex: null, value: "" });
//                               }}
//                               style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                             />
//                           ) : (
//                             <span style={{ flex: 1 }}>{point}</span>
//                           )}
//                           <FaEdit
//                             style={{ marginLeft: "10px", cursor: "pointer", color: "#007bff" }}
//                             onClick={() => setEditAdvisory({ lang: "tetum", index, pointIndex, value: point })}
//                           />
//                           <FaTrash
//                             style={{ marginLeft: "10px", cursor: "pointer", color: "#dc3545" }}
//                             onClick={() => handleDeleteAdvisoryPoint("tetum", index, pointIndex)}
//                           />
//                         </div>
//                       ))}
//                       <button
//                         onClick={() => handleAddAdvisoryPoint("tetum", index)}
//                         style={{ padding: "5px 10px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "4px", marginTop: "5px" }}
//                       >
//                         Add Point
//                       </button>
//                     </div>
//                   ))}
//                   <FaPlusCircle
//                     style={{ color: "#28a745", fontSize: "20px", cursor: "pointer", marginTop: "10px" }}
//                     onClick={() => handleAddAdvisoryType("tetum")}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Note Label</label>
//                   <input
//                     type="text"
//                     value={translations.tetum.noteLabel}
//                     onChange={(e) => handleInputChange("tetum", "noteLabel", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ display: "block", marginBottom: "5px" }}>Note Text</label>
//                   <textarea
//                     value={translations.tetum.noteText}
//                     onChange={(e) => handleInputChange("tetum", "noteText", e.target.value)}
//                     style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", minHeight: "80px" }}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "20px" }}>
//               <button
//                 onClick={() => {
//                   handleCloseEditModal();
//                   generateReports();
//                 }}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#007bff",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Generate PDFs
//               </button>
//               <button
//                 onClick={handleCloseEditModal}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#6c757d",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
// abama              </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showPdfModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "flex-start",
//             paddingTop: "20px",
//             zIndex: 9999,
//             overflow: "auto",
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "12px",
//               padding: "24px",
//               maxWidth: "90%",
//               width: "1000px",
//               boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <div style={{ display: "flex", gap: "20px", justifyContent: "space-between" }}>
//               <div style={{ flex: 1, textAlign: "center" }}>
//                 <h3 style={{ marginBottom: "10px", fontSize: "16px", color: "#333" }}>English PDF</h3>
//                 {englishPdf && (
//                   <iframe
//                     src={URL.createObjectURL(englishPdf)}
//                     style={{ width: "100%", height: "500px", border: "1px solid #ccc" }}
//                     title="English PDF Preview"
//                   />
//                 )}
//               </div>
//               <div style={{ flex: 1, textAlign: "center" }}>
//                 <h3 style={{ marginBottom: "10px", fontSize: "16px", color: "#333" }}>Tetum PDF</h3>
//                 {tetumPdf && (
//                   <iframe
//                     src={URL.createObjectURL(tetumPdf)}
//                     style={{ width: "100%", height: "500px", border: "1px solid #ccc" }}
//                     title="Tetum PDF Preview"
//                   />
//                 )}
//               </div>
//             </div>
//             <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
//               <button
//                 onClick={handleDownload}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#007bff",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Download Both PDFs
//               </button>
//               <button
//                 onClick={handleCancel}
//                 style={{
//                   padding: "10px 18px",
//                   borderRadius: "6px",
//                   backgroundColor: "#6c757d",
//                   color: "#fff",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="hotspot-container" ref={containerRef}>
//         <MapContainer
//           center={center}
//           zoom={INITIAL_VIEW_STATE.zoom}
//           style={{ height: "75vh", width: "100%" }}
//         >
//           <TileLayer
//             url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
//             attribution="Tiles © Esri — Esri, DeLorme, NAVTEQ"
//           />
//           <LayersControl position="topright">
//             {hotspotData && (
//               <LayersControl.Overlay name="Hotspots" checked>
//                 <GeoJSON
//                   data={hotspotData}
//                   style={hotspotStyle}
//                   onEachFeature={onEachHotspotFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {municipalityData && (
//               <LayersControl.Overlay name="Municipalities" checked>
//                 <GeoJSON
//                   data={municipalityData}
//                   style={municipalityStyle}
//                   onEachFeature={onEachMunicipalityFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {submunicipalityData && (
//               <LayersControl.Overlay name="Submunicipalities">
//                 <GeoJSON
//                   data={submunicipalityData}
//                   style={submunicipalityStyle}
//                   onEachFeature={onEachSubmunicipalityFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//             {sucoData && (
//               <LayersControl.Overlay name="Sucos">
//                 <GeoJSON
//                   data={sucoData}
//                   style={sucoStyle}
//                   onEachFeature={onEachSucoFeature}
//                 />
//               </LayersControl.Overlay>
//             )}
//           </LayersControl>
//           <div
//             style={{
//               position: "absolute",
//               bottom: "2px",
//               right: "2px",
//               background: "white",
//               padding: "10px",
//               border: "1px solid #ccc",
//               zIndex: 1000,
//             }}
//           >
//             <LegendItem color="rgba(255, 0, 0, 1)" label="Hotspots" />
//           </div>
//           {info && (
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "13px",
//                 left: "35px",
//                 fontSize: "12px",
//                 zIndex: 1000,
//                 backgroundColor: "white",
//                 padding: "5px",
//                 borderRadius: "5px",
//                 boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//               }}
//             >
//               72 hour hotspot information based on latest data is available from NDVI, LST.
//             </div>
//           )}
//           <InfoButton setInfo={setInfo} />
//         </MapContainer>
//       </div>
//     </>
//   );
// };

// const LegendItem = ({ color, label }) => (
//   <div style={{ marginBottom: "5px" }}>
//     <span
//       style={{
//         display: "inline-block",
//         width: "20px",
//         height: "10px",
//         background: color,
//         marginRight: "5px",
//       }}
//     ></span>
//     {label}
//   </div>
// );

// export default Hotspot;


import React, { useEffect, useState, useRef, useCallback } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import * as turf from "@turf/turf";
import domtoimage from "dom-to-image";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { FaCircleInfo } from "react-icons/fa6";
import { FaPlusCircle, FaTrash } from "react-icons/fa";
import { saveAs } from "file-saver";
import DescriptionIcon from "@mui/icons-material/Description";
import CircularProgress from "@mui/material/CircularProgress";
import { MapHomeControl, MapLegendControl } from "../../../common/MapControls/MapControls";

// Risk level translations
const initialTranslations = {
  en: {
    title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
    warningTitle: "Fire Hotspots Advisory for Timor-Leste",
    advisoryNumber: "Advisory number: ",
    issuedBy: "Issued by:",
    issuedAt: "Date & Time:",
    overview: "Overview",
    highRiskWarning: "A forecast has been issued for high fire risk hotspots in several sucos within [highRiskMunicipalities]. Immediate precautions are recommended to prevent fire outbreaks.",
    mapHeading: "Fire Hotspot Risk Map",
    tableHeaders: ["Municipality", "Sub-Municipality", "Suco", "Risk Level"],
    generalAdvisory: "General Advisory",
    advisoryIntro: "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and prevent fire outbreaks:",
    advisoryTableHeaders: ["Type", "Advisory"],
    advisoryPoints: [
      {
        type: "Do's",
        points: [
          "Secure flammable materials away from heat-prone areas.",
          "Ensure any outdoor fire or heat-producing activity is fully extinguished before leaving."
        ]
      },
      {
        type: "Don'ts",
        points: [
          "Do not light fires or burn waste near vegetation or dry areas.",
          "Do not engage in open burning activities during high heat periods.",
          "Avoid entering high-risk areas without proper protective gear or local clearance."
        ]
      },
      {
        type: "Prevention and Preparedness",
        points: [
          "Keep emergency contact numbers of fire services and local authorities easily accessible.",
          "Report any visible smoke, fire, or abnormal heat activity immediately.",
          "Avoid outdoor activities that may trigger sparks or fires, such as welding or fireworks near dry vegetation.",
          "Use lanterns, stoves, and heaters with caution in high-risk zones. Ensure equipment is cool before refueling.",
          "Dispose of smoking materials like cigarettes safely and away from dry areas.",
          "Do not burn agricultural, industrial, or municipal waste near hotspot regions.",
          "Prepare and maintain defensible space around homes in at-risk zones by clearing dry debris and combustibles.",
          "Ensure availability of emergency kits and pre-plan evacuation routes.",
          "Conduct preparedness drills regularly and identify safe zones in your community."
        ]
      },
      {
        type: "Evacuation in Case of Extreme Heat or Fire Hotspot Escalation",
        points: [
          "Evacuate immediately upon advisories from local authorities or emergency services.",
          "Protect yourself from heat exposure and possible airborne particles.",
          "Secure your animals and assist vulnerable individuals during evacuation."
        ]
      },
      {
        type: "Before Leaving Your House",
        points: [
          "Remove all combustible items like gas cylinders, firewood, and dry waste from your surroundings.",
          "Seal windows, vents, and doors to minimize smoke or heat intrusion.",
          "Store water in large containers to use in case of emergency cooling.",
          "Trim dry plants and clean debris around your property to reduce ignition risk.",
          "Inspect and clean rooftops, gutters, and drainage areas regularly.",
          "Dampen roofs and exterior walls if advised by emergency services during high-risk alerts."
        ]
      },
      {
        type: "If Exposed to a Hotspot While Outdoors",
        points: [
          "Avoid attempting to outrun fire or heat. Seek refuge in a cleared, low-vegetation area.",
          "Cover your nose and mouth with a wet cloth to reduce smoke inhalation risk.",
          "Use water, soil, or nonflammable materials to shield yourself if surrounded by heat or fire."
        ]
      },
      {
        type: "If Sheltering at Home During a Heat Alert or Hotspot Activation",
        points: [
          "Stay calm and indoors. Seal your home to prevent heat and smoke entry.",
          "Avoid opening hot doors — it may indicate fire or intense heat on the other side.",
          "Monitor official updates for when it's safe to evacuate or step out."
        ]
      },
      {
        type: "If Caught in a Vehicle in a Hotspot-Affected Area",
        points: [
          "Stay inside the vehicle — it offers better protection than open space.",
          "Keep windows and air vents closed to avoid smoke and heat exposure.",
          "Drive cautiously with headlights on and remain alert to surroundings.",
          "If stopping, park away from vegetation and turn off the engine.",
          "Stay low inside the vehicle and cover yourself with nonflammable material."
        ]
      }
    ],
    noteLabel: "Note:",
    noteText: "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
    footer: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
    page: "Page [i] of [pageCount]",
  },
  tetum: {
    title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
    warningTitle: "Avisu kona ba Rai Manas iha Timor-Leste",
    advisoryNumber: "Númeru Aviso:",
    issuedBy: "Ema-husik husi:",
    issuedAt: "Data no Oras:",
    overview: "VISAUN JERAL",
    highRiskWarning: "Forescast ida ema-husik ona kona-ba risku foho altus iha suco balun iha [highRiskMunicipalities]. Rekomenda prevensaun imediata atu prevene foho.",
    mapHeading: "MAPA RISKU HOTSPOT FOHO",
    tableHeaders: ["Munisípiu", "Sub-munisípiu", "Suco", "Nivel Risku"],
    generalAdvisory: "KONSELLU JERAL",
    advisoryIntro: "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no prevene foho:",
    advisoryTableHeaders: ["Tipu", "Konsellu"],
    advisoryPoints: [
      {
        type: "Diak Halo",
        points: [
          "Tau hela materiál sira ne'ebé bele haksolok fatin hela toos no manas.",
          "Konfirma katak hela-fatin ne'ebé manas ka iha api, sei la iha risku fatin molok ita halai."
        ]
      },
      {
        type: "Labele Halo",
        points: [
          "Labele sunu ai-ruin ka lixu besik toos ka fatin matak.",
          "Labele halo sunu iha loron ne'ebé manas tebes.",
          "Labele tama iha fatin risku boot tan manas boot la'ós ho proteksaun loos ka klaru husi autoridade lokal."
        ]
      },
      {
        type: "Prevensaun no Preparasaun",
        points: [
          "Tau hela numeru kontaktu emergencia hosi servisu bombeiru no autoridade lokal.",
          "Hatete lalais ba autoridade se haree sukun, api, ka manas boot ne'ebé la normal.",
          "Labele halo atividade iha liur ne'ebé bele halo iskra ka api, hanesan soldadura ka fogu d'artifísiu besik ai matak.",
          "Uza lanterna, fogão, no aparato manas ho atensaun iha fatin manas. Labele tau gasolina antes ne'ebé aparatu cool.",
          "Hamoos sigaru, fósforu, no materiál fumar iha fatin ne'ebé seguru, labele hikas iha fatin matak.",
          "Labele sunu restu agrikultura, indústria ka lixu municipal besik hotspot.",
          "Hamoos ai-ruin matak no materiál haksolok iha zona risku, prepara área seguransa iha entorno uma.",
          "Prepara hela kit emergencia no buat sira ne'ebé importante ba evacuasaun.",
          "Halo simulasaun evacuasaun no hatene fatin seguransa iha komunidade."
        ]
      },
      {
        type: "Evakuasaun iha tempu manas ka eskalasaun hotspot",
        points: [
          "Sai hela fatin tan dehan hosi autoridade lokal ka servisu emergencia.",
          "Proteje-an hosi manas tebes no partículas iha ar.",
          "Toman konta animal sira no ajuda ema matak ka ema ne'ebé iha nesesidade espesiál."
        ]
      },
      {
        type: "Molok Sai husi Uma",
        points: [
          "Taka no hasai buat hotu ne'ebé haksolok hanesan botija gas, ai-ruin, no lixu matak iha entorno uma.",
          "Taka janela, ventilasaun no odamatan atu prevene fumaça ka manas tama.",
          "Tau bee iha vasilha boot atu uza ba manan manas ka fumaça.",
          "Kose ai-ruin matak no halo limpu zona iha nia sorin uma.",
          "Hamoos telhado, kalha no fatin saluran bee.",
          "Tau bee iha telhado, paredes no ai sira iha sorin uma karik iha alerta hosi autoridade."
        ]
      },
      {
        type: "Se Ita iha Liur iha Fatin Hotspot",
        points: [
          "Labele halai atu la'o husi api. Bolu hela iha fatin ne'ebé matak no buka área klaru.",
          "Kobre-an ho kanuru molik atu prevene fumaça tama iha matan no anin.",
          "Uza bee, rai, ka materiál ne'ebé la bele sunu atu proteje-an se iha risku boot iha fatin."
        ]
      },
      {
        type: "Se Ita iha Uma Durante Alerta Hotspot",
        points: [
          "Tuir diak, hela iha uma. Taka buat hotu atu prevene fumaça ka manas tama.",
          "Se odamatan manas tebes, labele taka tan bele iha api iha fatin seluk.",
          "Tuir informasaun ofisiál ba tempu ne'ebé seguru atu sai ka evacuate."
        ]
      },
      {
        type: "Se Ita iha Karreta iha Fatin Hotspot",
        points: [
          "Hela iha laran karreta — liu seguru liu dukur iha liur.",
          "Taka janela no ventilasaun atu prevene fumaça ka manas tama.",
          "La'o ho kuidadu no laran moris iha luz karreta.",
          "Se presiza para: para iha fatin ne'ebé laduun iha vegetasaun, taka motor.",
          "Hela iha laran karreta no tuun ba rai.",
          "Kobre-an ho ropa ka materiál ne'ebé la bele sunu."
        ]
      }
    ],
    noteLabel: "Nota:",
    noteText: "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
    footer: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
    page: "Pajina [i] husi [pageCount]",
  },
};

// Risk level translations
const riskLevelTranslations = {
  en: { 3: "High Risk" },
  tetum: { 3: "Risku Altus" },
};

// Helper function to load images
const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

// Helper function to add banner to a page
const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
  const bannerHeight = 20; // Height in mm
  const bannerWidth = pageWidth - 2 * sideMargin; // Span page width minus margins
  if (bannerImage) {
    pdf.addImage(
      bannerImage,
      "PNG",
      sideMargin,
      topMargin,
      bannerWidth,
      bannerHeight
    );
  }
  return topMargin + bannerHeight + 5; // Return new currentY (5mm gap)
};

// Function to generate PDF and return as Blob
const generatePdfWithImage = async (dataUrl, hotspotTable, municipalityData, language = "en", translations) => {
  try {
    const pdf = new jsPDF("portrait", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm
    const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
    const sideMargin = 10;
    const topMargin = 10;
    const footerHeight = 10;
    const marginBottom = 10;
    const bannerHeight = 20; // Assumed banner height
    const headerHeight = topMargin + bannerHeight + 5; // 35 mm (10 + 20 + 5)
    const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom; // ~242 mm
    let currentY;

    const t = translations[language];
    const riskT = riskLevelTranslations[language];

    // Load banner image based on language
    let bannerImage;
    const bannerPath = language === "en" ? "/pdf/banner.png" : "/pdf/tetumbanner.png";
    try {
      bannerImage = await loadImage(bannerPath);
    } catch (error) {
      console.warn(`Failed to load ${bannerPath}:`, error);
      bannerImage = null;
    }

    // Helper function to add page with header
    const addPageWithHeader = () => {
      pdf.addPage();
      return addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
    };

    // Add banner to first page
    currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
    currentY += 5;

    // Add warning title
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.setTextColor(0, 0, 0);
    if (currentY + 10 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.text(t.warningTitle, pageWidth / 2, currentY, { align: "center" });
    pdf.setTextColor(0, 0, 0);
    currentY += 10;

    // Format date in Asia/Dili timezone
    const now = new Date();
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Dili",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(now);

    const [datePart, timePartRaw] = formattedDate.split(", ");
    const [day, month, year] = datePart.split("/");
    const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
    const [ hour, minute, second, period] = timeMatch;
    const formattedTimorDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;

    pdf.setFontSize(10);

    // Ensure enough space, else add page
    if (currentY + 6 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }

    // Prepare left and right text with bold labels
    pdf.setFont("helvetica", "bold");
    const advisoryNumberLabel = t.advisoryNumber;
    pdf.text(advisoryNumberLabel, sideMargin, currentY);
    pdf.setFont("helvetica", "normal");
    pdf.text(" 1", sideMargin + pdf.getTextWidth(advisoryNumberLabel) + 2, currentY);
    pdf.setFont("helvetica", "bold");
    const issuedAtLabel = t.issuedAt;
    const rightText = `${issuedAtLabel} ${formattedTimorDate}`;
    const rightTextWidth = pdf.getTextWidth(rightText);
    const rightX = pageWidth - sideMargin - rightTextWidth;
    pdf.text(issuedAtLabel, rightX, currentY);
    pdf.setFont("helvetica", "normal");
    pdf.text(formattedTimorDate, rightX + pdf.getTextWidth(issuedAtLabel) + 2, currentY);
    currentY += 6;

    // Issued by
    if (currentY + 6 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.setFont("helvetica", "bold");
    const issuedByLabel = t.issuedBy;
    pdf.text(issuedByLabel, sideMargin, currentY);
    pdf.setFont("helvetica", "normal");
    pdf.text("Department of Meteorology", sideMargin + pdf.getTextWidth(issuedByLabel) + 2, currentY);
    currentY += 6;

    currentY += 5;

    // Identify high-risk municipalities
    const highRiskMunicipalities = [...new Set(
      hotspotTable
        .filter((row) => row.risk >= 3)
        .map((row) => row.municipality)
    )].join(", ") || (language === "en" ? "No high-risk areas identified" : "Laiha fatin ho risku altus identifika");

    currentY += 5;

    // OVERVIEW section
    if (currentY + 10 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");
    pdf.setFillColor(202, 217, 239); // Background color (light blue)
    pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
    pdf.setTextColor(0, 0, 0); // Black text
    pdf.text(t.overview, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
    pdf.setTextColor(0, 0, 0); // Reset text color
    currentY += 10;

    // Warning message
    const warningText = [t.highRiskWarning.replace("[highRiskMunicipalities]", highRiskMunicipalities)];
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "normal");
    warningText.forEach((line) => {
      const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
      lines.forEach((splitLine) => {
        if (currentY + 6 > availablePageHeight + headerHeight) {
          currentY = addPageWithHeader();
        }
        pdf.text(splitLine, sideMargin, currentY);
        currentY += 6;
      });
      currentY += 2;
    });
    currentY += 5;

    currentY += 2;

    // MAP heading
    if (currentY + 10 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");
    pdf.setFillColor(202, 217, 239); // Background color (light blue)
    pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F"); // Rectangle for background
    pdf.setTextColor(0, 0, 0); // Black text
    pdf.text(t.mapHeading, sideMargin + 2, currentY - 2, { align: "left" }); // Left-aligned with padding
    pdf.setTextColor(0, 0, 0); // Reset text color
    currentY += 5;

    // Add map image
    if (dataUrl) {
      const img = await loadImage(dataUrl);
      const availableWidth = pageWidth - 2 * sideMargin;
      const imgHeight = (img.height * availableWidth) / img.width;

      if (currentY + imgHeight + 5 > availablePageHeight + headerHeight) {
        currentY = addPageWithHeader();
      }

      pdf.addImage(dataUrl, "PNG", sideMargin, currentY, availableWidth, imgHeight);
      currentY += imgHeight + 5;
    } else {
      console.warn("No map image provided for PDF");
    }
    currentY += 5;

    // Prepare table data
    const tableData = hotspotTable.map((row) => [
      row.municipality,
      row.submunicipality,
      row.suco,
      riskT[row.risk] || row.risk,
    ]);

    // Add table
    if (currentY + 20 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    autoTable(pdf, {
      startY: currentY,
      head: [t.tableHeaders],
      body: tableData,
      theme: "grid",
      headStyles: { fillColor: [225, 232, 242], halign: "left", fontStyle: "bold", textColor: "black" },
      styles: { fontSize: 9, cellPadding: 3 },
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 40 },
        2: { cellWidth: 40 },
        3: { cellWidth: 40 },
      },
      margin: { left: sideMargin, right: sideMargin, top: headerHeight },
      willDrawPage: (data) => {
        data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
      },
      didDrawPage: (data) => {
        currentY = data.cursor.y + 10;
      },
    });

    currentY += 5;

    // GENERAL ADVISORY section
    if (currentY + 10 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");
    pdf.setFillColor(202, 217, 239);
    pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F");
    pdf.setTextColor(0, 0, 0);
    pdf.text(t.generalAdvisory, sideMargin + 2, currentY - 1, { align: "left" });
    pdf.setTextColor(0, 0, 0);
    currentY += 7;

    currentY += 5;

    // Add advisory intro
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "normal");
    if (currentY + 6 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    const introLines = pdf.splitTextToSize(t.advisoryIntro, pageWidth - 2 * sideMargin);
    introLines.forEach((line) => {
      if (currentY + 6 > availablePageHeight + headerHeight) {
        currentY = addPageWithHeader();
      }
      pdf.text(line, sideMargin, currentY);
      currentY += 6;
    });

    currentY += 5;

    // Prepare table data for advisory with bullet points
    const advisoryTableData = t.advisoryPoints.map((category) => [
      category.type,
      category.points.map((point) => `• ${point}`).join("\n")
    ]);

    // Add advisory table
    if (currentY + 20 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    autoTable(pdf, {
      startY: currentY,
      head: [t.advisoryTableHeaders],
      body: advisoryTableData,
      theme: "grid",
      headStyles: {
        fillColor: [225, 232, 242],
        halign: "left",
        fontStyle: "bold",
        textColor: "black",
      },
      styles: {
        fontSize: 9,
        cellPadding: { top: 3, right: 3, bottom: 3, left: 5 },
        overflow: "linebreak",
        lineHeight: 1.2,
      },
      columnStyles: {
        0: { cellWidth: 40, halign: "left" },
        1: { cellWidth: pageWidth - 2 * sideMargin - 40, halign: "left" },
      },
      margin: { left: sideMargin, right: sideMargin, top: headerHeight },
      willDrawPage: (data) => {
        data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
      },
      didDrawPage: (data) => {
        currentY = data.cursor.y + 10;
      },
    });

    currentY += 5;

    // Add Note section
    if (currentY + 12 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "bold");
    pdf.text(t.noteLabel, sideMargin, currentY);
    currentY += 6;
    pdf.setFont("helvetica", "normal");
    const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
    noteLines.forEach((line) => {
      if (currentY + 6 > availablePageHeight + headerHeight) {
        currentY = addPageWithHeader();
      }
      pdf.text(line, sideMargin, currentY);
      currentY += 6;
    });
    currentY += 4;

    currentY += 12;

    if (currentY + 6 > availablePageHeight + headerHeight) {
      currentY = addPageWithHeader();
    }
    pdf.setFont("helvetica", "bold");
    pdf.text("*****", (pageWidth - pdf.getTextWidth("*****")) / 2, currentY);
    currentY += 6;
    pdf.setFont("helvetica", "normal");

    // Add footer to all pages
    const pageCount = pdf.internal.getNumberOfPages();
    const footerYOffset = 5;
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(8);
      pdf.text(
        t.footer,
        pageWidth / 2,
        pageHeight - footerHeight + footerYOffset - 2,
        { align: "center" }
      );
      pdf.text(
        t.page.replace("[i]", i).replace("[pageCount]", pageCount),
        pageWidth / 2,
        pageHeight - footerHeight + footerYOffset + 3,
        { align: "center" }
      );
    }

    // Return PDF as Blob
    return pdf.output("blob");
  } catch (error) {
    console.error("Failed to generate PDF:", error);
    throw error;
  }
};

const InfoButton = ({ onClick }) => {
  useMap();
  // Leaflet's own drag/click handling swallows clicks on overlay controls
  // unless propagation to the map is explicitly disabled on the DOM node.
  const btnRef = useCallback((node) => {
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  return (
    <div
      ref={btnRef}
      style={{
        position: "absolute",
        bottom: "20px",
        left: "12px",
        padding: "8px",
        borderRadius: "8px",
        fontSize: "15px",
        cursor: "pointer",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px) brightness(1.1)",
        WebkitBackdropFilter: "blur(10px) brightness(1.1)",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        color: "#333333",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "all 0.2s ease",
        zIndex: 1000,
      }}
      onClick={onClick}
    >
      <FaCircleInfo />
    </div>
  );
};

const Hotspot = () => {
  const [hotspotData, setHotspotData] = useState(null);
  const [municipalityData, setMunicipalityData] = useState(null);
  const [submunicipalityData, setSubmunicipalityData] = useState(null);
  const [sucoData, setSucoData] = useState(null);
  const [hotspotTable, setHotspotTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState(false);
  const infoRef = useRef(null);
  const infoPanelRef = useCallback((node) => {
    infoRef.current = node;
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  useEffect(() => {
    if (!info) return;
    const handleClickOutside = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) setInfo(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [info]);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [englishPdf, setEnglishPdf] = useState(null);
  const [tetumPdf, setTetumPdf] = useState(null);
  const [translations, setTranslations] = useState(initialTranslations);
  const containerRef = useRef(null);

  const center = [-8.7742, 125.675]; // Timor-Leste
  const INITIAL_VIEW_STATE = {
    zoom: 8.5,
  };

  // Fetch hotspot data
  useEffect(() => {
    fetch("/cityfire/Hotspot_Areas_FireRisk_JSON_F2.geojson")
      .then((response) => response.json())
      .then((data) => setHotspotData(data))
      .catch((error) => console.error("Error loading hotspot data:", error));
  }, []);

  // Fetch municipality data
  useEffect(() => {
    fetch("/DATA/OSMbased_adm1_boundary.json")
      .then((response) => response.json())
      .then((data) => setMunicipalityData(data))
      .catch((error) => console.error("Error loading municipality data:", error));
  }, []);

  // Fetch submunicipality data
  useEffect(() => {
    fetch("/DATA/OSMbased_adm2_boundary.json")
      .then((response) => response.json())
      .then((data) => setSubmunicipalityData(data))
      .catch((error) => console.error("Error loading submunicipality data:", error));
  }, []);

  // Fetch suco data
  useEffect(() => {
    fetch("/DATA/OSMbased_adm3_boundary.json")
      .then((response) => response.json())
      .then((data) => setSucoData(data))
      .catch((error) => console.error("Error loading suco data:", error));
  }, []);

  // Process hotspot data to build the table
  useEffect(() => {
    if (hotspotData && sucoData && submunicipalityData && municipalityData) {
      const tableData = hotspotData.features.map((hotspot) => {
        const centroid = turf.centroid(hotspot);

        let sucoName = "Unknown";
        let submunicipalityName = "Unknown";
        let municipalityName = "Unknown";

        const sucoFeature = sucoData.features.find((suco) =>
          turf.booleanPointInPolygon(centroid, suco)
        );
        if (sucoFeature && sucoFeature.properties) {
          sucoName = sucoFeature.properties.ADM3 || "Unknown";

          const sucoCentroid = turf.centroid(sucoFeature);
          const submunicipalityFeature = submunicipalityData.features.find((sub) =>
            turf.booleanPointInPolygon(sucoCentroid, sub)
          );
          if (submunicipalityFeature && submunicipalityFeature.properties) {
            submunicipalityName = submunicipalityFeature.properties.ADM2 || "Unknown";

            const subCentroid = turf.centroid(submunicipalityFeature);
            const municipalityFeature = municipalityData.features.find((mun) =>
              turf.booleanPointInPolygon(subCentroid, mun)
            );
            if (municipalityFeature && municipalityFeature.properties) {
              municipalityName = municipalityFeature.properties.ADM1 || "Unknown";
            }
          }
        }

        return {
          suco: sucoName,
          submunicipality: submunicipalityName,
          municipality: municipalityName,
          risk: hotspot.properties.risk || "Unknown",
        };
      });
      setHotspotTable(tableData);
    }
  }, [hotspotData, sucoData, submunicipalityData, municipalityData]);

  // Handle PDF generation and preview
  const generateReports = async () => {
    const containerElement = containerRef.current;
    if (!containerElement || !hotspotTable.length) {
      console.warn("Cannot generate report: container or hotspotTable missing");
      alert("Cannot generate report: Data is missing.");
      return;
    }

    setLoading(true);
    try {
      const dataUrl = await domtoimage.toPng(containerElement, {
        width: containerElement.offsetWidth,
        height: containerElement.offsetHeight,
        style: { background: "white" },
        quality: 0.95,
      });

      // Generate both PDFs
      const englishPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "en", translations);
      const tetumPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "tetum", translations);

      setEnglishPdf(englishPdfBlob);
      setTetumPdf(tetumPdfBlob);
      setShowPdfModal(true);
    } catch (error) {
      console.error("Failed to capture image or generate PDFs:", error);
      alert("Failed to generate PDFs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Update PDFs when translations change
  useEffect(() => {
    if (showPdfModal && hotspotTable.length) {
      const updatePdfs = async () => {
        try {
          const dataUrl = await domtoimage.toPng(containerRef.current, {
            width: containerRef.current.offsetWidth,
            height: containerRef.current.offsetHeight,
            style: { background: "white" },
            quality: 0.95,
          });
          const englishPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "en", translations);
          const tetumPdfBlob = await generatePdfWithImage(dataUrl, hotspotTable, municipalityData, "tetum", translations);
          setEnglishPdf(englishPdfBlob);
          setTetumPdf(tetumPdfBlob);
        } catch (error) {
          console.error("Failed to update PDFs:", error);
          alert("Failed to update PDFs. Please try again.");
        }
      };
      updatePdfs();
    }
  }, [translations, showPdfModal, hotspotTable, municipalityData]);

  // Handle download of both PDFs
  const handleDownload = () => {
    if (englishPdf && tetumPdf) {
      saveAs(englishPdf, "DRRDSS-Hotspot-Advisory-English.pdf");
      saveAs(tetumPdf, "DRRDSS-Hotspot-Advisory-Tetum.pdf");
    } else {
      alert("PDFs are not ready for download.");
    }
  };

  // Handle cancel
  const handleCancel = () => {
    setShowPdfModal(false);
    setEnglishPdf(null);
    setTetumPdf(null);
    setTranslations(initialTranslations); // Reset translations to initial state
  };

  // Handle text field changes
  const handleTextChange = (language, field, value) => {
    setTranslations((prev) => ({
      ...prev,
      [language]: {
        ...prev[language],
        [field]: value,
      },
    }));
  };

  // Handle advisory point changes
  const handleAdvisoryPointChange = (language, typeIndex, pointIndex, value) => {
    setTranslations((prev) => {
      const newPoints = [...prev[language].advisoryPoints[typeIndex].points];
      newPoints[pointIndex] = value;
      const newAdvisoryPoints = [...prev[language].advisoryPoints];
      newAdvisoryPoints[typeIndex] = {
        ...newAdvisoryPoints[typeIndex],
        points: newPoints,
      };
      return {
        ...prev,
        [language]: {
          ...prev[language],
          advisoryPoints: newAdvisoryPoints,
        },
      };
    });
  };

  // Handle adding a new advisory type
  const handleAddAdvisoryType = (language) => {
    setTranslations((prev) => {
      const newType = {
        type: `New Type ${prev[language].advisoryPoints.length + 1}`,
        points: ["Enter new advisory point"],
      };
      return {
        ...prev,
        [language]: {
          ...prev[language],
          advisoryPoints: [...prev[language].advisoryPoints, newType],
        },
      };
    });
  };

  // Handle deleting an advisory point
  const handleDeleteAdvisoryPoint = (language, typeIndex, pointIndex) => {
    setTranslations((prev) => {
      const newPoints = [...prev[language].advisoryPoints[typeIndex].points];
      newPoints.splice(pointIndex, 1);
      const newAdvisoryPoints = [...prev[language].advisoryPoints];
      newAdvisoryPoints[typeIndex] = {
        ...newAdvisoryPoints[typeIndex],
        points: newPoints,
      };
      return {
        ...prev,
        [language]: {
          ...prev[language],
          advisoryPoints: newAdvisoryPoints,
        },
      };
    });
  };

  // Handle adding a new advisory point
  const handleAddAdvisoryPoint = (language, typeIndex) => {
    setTranslations((prev) => {
      const newPoints = [...prev[language].advisoryPoints[typeIndex].points, "Enter new advisory point"];
      const newAdvisoryPoints = [...prev[language].advisoryPoints];
      newAdvisoryPoints[typeIndex] = {
        ...newAdvisoryPoints[typeIndex],
        points: newPoints,
      };
      return {
        ...prev,
        [language]: {
          ...prev[language],
          advisoryPoints: newAdvisoryPoints,
        },
      };
    });
  };

  // Handle advisory type name change
  const handleAdvisoryTypeChange = (language, typeIndex, value) => {
    setTranslations((prev) => {
      const newAdvisoryPoints = [...prev[language].advisoryPoints];
      newAdvisoryPoints[typeIndex] = {
        ...newAdvisoryPoints[typeIndex],
        type: value,
      };
      return {
        ...prev,
        [language]: {
          ...prev[language],
          advisoryPoints: newAdvisoryPoints,
        },
      };
    });
  };

  // Styles for GeoJSON layers
  const hotspotStyle = {
    color: "red",
    weight: 2,
    fillColor: "red",
    fillOpacity: 0.9,
  };

  const municipalityStyle = {
    color: "black",
    weight: 0.5,
    fillColor: "blue",
    fillOpacity: 0.0,
  };

  const submunicipalityStyle = {
    color: "green",
    weight: 2,
    fillColor: "green",
    fillOpacity: 0.0,
  };

  const sucoStyle = {
    color: "black",
    weight: 1,
    fillColor: "gray",
    fillOpacity: 0.1,
  };

  // Handle feature interactions
  const onEachHotspotFeature = (feature, layer) => {
    if (feature.properties) {
      const popupContent = `
        <b>Hotspot</b><br>
        ID: ${feature.id || "Unknown"}<br>
        Risk: ${feature.properties.risk || "Unknown"}<br>
        Count: ${feature.properties.count || "Unknown"}
      `;
      layer.bindPopup(popupContent);
    }
  };

  const onEachMunicipalityFeature = (feature, layer) => {
    if (feature.properties) {
      const popupContent = `<b>Municipality</b>: ${feature.properties.ADM1 || "Unknown"}`;
      layer.bindPopup(popupContent);
    }
  };

  const onEachSubmunicipalityFeature = (feature, layer) => {
    if (feature.properties) {
      const popupContent = `<b>Submunicipality</b>: ${feature.properties.ADM2 || "Unknown"}`;
      layer.bindPopup(popupContent);
    }
  };

  const onEachSucoFeature = (feature, layer) => {
    if (feature.properties) {
      const popupContent = `<b>Suco</b>: ${feature.properties.ADM3 || "Unknown"}`;
      layer.bindPopup(popupContent);
    }
  };

  return (
    <>
      {/* <button
        onClick={generateReports}
        disabled={loading}
        style={{
          padding: "4px 6px",
          borderRadius: "6px",
          backgroundColor: "blue",
          color: "#333333",
          marginBottom: "5px",
          marginLeft: "87%",
          top: "0px",
          right: "0px",
          border: "none",
        }}
      >
        {loading ? "Generating..." : "Generate Report"}
      </button> */}
      {showPdfModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            paddingTop: "20px",
            zIndex: 9999,
            overflow: "auto",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "24px",
              maxWidth: "1400px",
              width: "90%",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div style={{ display: "flex", gap: "20px" }}>
              {/* Editing Panel */}
              <div style={{ flex: 1, maxWidth: "400px", overflowY: "auto", maxHeight: "600px", padding: "10px", border: "1px solid #ccc" }}>
                <h3 style={{ fontSize: "16px", color: "#333", marginBottom: "10px" }}>Edit PDF Content</h3>
                {["en", "tetum"].map((lang) => (
                  <div key={lang} style={{ marginBottom: "20px" }}>
                    <h4 style={{ fontSize: "14px", color: "#007bff", marginBottom: "10px" }}>{lang === "en" ? "English" : "Tetum"}</h4>
                    {/* Warning Title */}
                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontSize: "12px", fontWeight: "bold" }}>Warning Title</label>
                      <input
                        type="text"
                        value={translations[lang].warningTitle}
                        onChange={(e) => handleTextChange(lang, "warningTitle", e.target.value)}
                        style={{ width: "100%", padding: "5px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px" }}
                      />
                    </div>
                    {/* High Risk Warning */}
                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontSize: "12px", fontWeight: "bold" }}>High Risk Warning</label>
                      <textarea
                        value={translations[lang].highRiskWarning}
                        onChange={(e) => handleTextChange(lang, "highRiskWarning", e.target.value)}
                        style={{ width: "100%", padding: "5px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", minHeight: "60px" }}
                      />
                    </div>
                    {/* Advisory Intro */}
                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontSize: "12px", fontWeight: "bold" }}>Advisory Intro</label>
                      <textarea
                        value={translations[lang].advisoryIntro}
                        onChange={(e) => handleTextChange(lang, "advisoryIntro", e.target.value)}
                        style={{ width: "100%", padding: "5px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", minHeight: "60px" }}
                      />
                    </div>
                    {/* Advisory Points */}
                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "5px" }}>
                        Advisory Points
                        <FaPlusCircle
                          color="green"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleAddAdvisoryType(lang)}
                        />
                      </label>
                      {translations[lang].advisoryPoints.map((category, typeIndex) => (
                        <div key={typeIndex} style={{ marginBottom: "10px", paddingLeft: "10px" }}>
                          <input
                            type="text"
                            value={category.type}
                            onChange={(e) => handleAdvisoryTypeChange(lang, typeIndex, e.target.value)}
                            style={{ width: "100%", padding: "5px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", marginBottom: "5px" }}
                          />
                          {category.points.map((point, pointIndex) => (
                            <div key={pointIndex} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                              <textarea
                                value={point}
                                onChange={(e) => handleAdvisoryPointChange(lang, typeIndex, pointIndex, e.target.value)}
                                style={{ width: "100%", padding: "5px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", minHeight: "40px" }}
                              />
                              <FaTrash
                                color="red"
                                style={{ cursor: "pointer", marginLeft: "5px" }}
                                onClick={() => handleDeleteAdvisoryPoint(lang, typeIndex, pointIndex)}
                              />
                            </div>
                          ))}
                          <button
                            onClick={() => handleAddAdvisoryPoint(lang, typeIndex)}
                            style={{
                              padding: "5px 10px",
                              backgroundColor: "#28a745",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            Add Point
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              {/* PDF Previews */}
              <div style={{ flex: 2, display: "flex", gap: "20px", justifyContent: "space-between" }}>
                <div style={{ flex: 1, textAlign: "center" }}>
                  <h3 style={{ marginBottom: "10px", fontSize: "16px", color: "#333" }}>English PDF</h3>
                  {englishPdf && (
                    <iframe
                      src={URL.createObjectURL(englishPdf)}
                      style={{ width: "100%", height: "600px", border: "1px solid #ccc" }}
                      title="English PDF Preview"
                    />
                  )}
                </div>
                <div style={{ flex: 1, textAlign: "center" }}>
                  <h3 style={{ marginBottom: "10px", fontSize: "16px", color: "#333" }}>Tetum PDF</h3>
                  {tetumPdf && (
                    <iframe
                      src={URL.createObjectURL(tetumPdf)}
                      style={{ width: "100%", height: "600px", border: "1px solid #ccc" }}
                      title="Tetum PDF Preview"
                    />
                  )}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
              <button
                onClick={handleDownload}
                style={{
                  padding: "10px 18px",
                  borderRadius: "6px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
              >
                Download PDFs
              </button>
              <button
                onClick={handleCancel}
                style={{
                  padding: "10px 18px",
                  borderRadius: "6px",
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="hotspot-container" ref={containerRef}>
        <MapContainer
          center={center}
          zoom={INITIAL_VIEW_STATE.zoom}
          style={{ height: "75vh", width: "100%" }}
        >
          <MapHomeControl />
          <TileLayer
            url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
            attribution="Tiles © Esri — Esri, DeLorme, NAVTEQ"
          />

                  <div className="icon-with-tooltip">
                    <button
                      className="report-buttons"
                      onClick={generateReports}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        <DescriptionIcon />
                      )}{" "}
                      <span className="tooltip-text">Generate Report</span>
                    </button>
                  </div>
          <LayersControl position="topright">
            {hotspotData && (
              <LayersControl.Overlay name="Hotspots" checked>
                <GeoJSON
                  data={hotspotData}
                  style={hotspotStyle}
                  onEachFeature={onEachHotspotFeature}
                />
              </LayersControl.Overlay>
            )}
            {municipalityData && (
              <LayersControl.Overlay name="Municipality" checked>
                <GeoJSON
                  data={municipalityData}
                  style={municipalityStyle}
                  onEachFeature={onEachMunicipalityFeature}
                />
              </LayersControl.Overlay>
            )}
            {submunicipalityData && (
              <LayersControl.Overlay name="Post Admin">
                <GeoJSON
                  data={submunicipalityData}
                  style={submunicipalityStyle}
                  onEachFeature={onEachSubmunicipalityFeature}
                />
              </LayersControl.Overlay>
            )}
            {sucoData && (
              <LayersControl.Overlay name="Suco">
                <GeoJSON
                  data={sucoData}
                  style={sucoStyle}
                  onEachFeature={onEachSucoFeature}
                />
              </LayersControl.Overlay>
            )}
          </LayersControl>

          {info && (
            <div
              ref={infoPanelRef}
              style={{
                position: "absolute",
                bottom: "70px",
                left: "12px",
                fontSize: "12px",
                zIndex: 1000,
                padding: "10px 14px",
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px) brightness(1.1)",
                WebkitBackdropFilter: "blur(10px) brightness(1.1)",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.5)",
                color: "#333333",
                fontWeight: "500",
                maxWidth: "320px",
                lineHeight: "1.4",
              }}
            >
              72 hour hotspot information based on latest data is available from NDVI, LST.
            </div>
          )}
          <InfoButton onClick={() => setInfo(!info)} />

          <MapLegendControl sections={[{ items: [{ label: "Hotspot", color: "rgb(230, 45, 58)" }] }]} />
        </MapContainer>
      </div>
    </>
  );
};



export default Hotspot;